import { Component, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivityTableComponent } from '../activity-table/activity-table.component';


@Component({
	selector: 'app-activities',
	templateUrl: './activities.component.html',
	styleUrls: ['./activities.component.scss']
})
export class ActivitiesComponent implements OnInit {
	@Input() selected_user_data: any;
	@Input() selected_page_action: any;
	@Input() selected_activity_type: any;
	@Input() selected_view_type: any;
	@Input() coaching_plan: any;
	@Input() stepper_stage: any;
	@Input() section_type: any;

	@Input() activity_action_type: any;


	@Input() selected_activity_type_id: any;

	@Output() dataChanged = new EventEmitter<any>();

	// selected_optimize_book_tab: any = 'By Date';
	// to_do_date: any = new Date();
	// current_date: any = new Date();

	// action_item_selected: string = 'email';
	// notification_item_selected: string = 'pending task';

	user_details: any;
	user_role: any;

	activities_table_header: any = [];

	advisor_manager_header: any = [
		{
			name: "Advisor Name",
			key: "advisor_name"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Actual Date",
			key: "actual_date"
		},
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "stage"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Description",
			key: "description"
		}
	];

	advisor_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		// {
		// 	name: "Client Name",
		// 	key: "client_name"
		// },
		{
			name: "Activity Name",
			key: "name"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Actual Date",
			key: "actual_date"
		},
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "stage"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		// {
		// 	name: "Assigned by",
		// 	key: "lead_advisor_full_name"
		// },
		// {
		// 	name: "Notified to",
		// 	key: "notified_to"
		// },
		{
			name: "Description",
			key: "description"
		},
	];

	afa_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		// {
		// 	name: "Client Name",
		// 	key: "client_name"
		// },
		{
			name: "Activity Name",
			key: "name"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Actual Date",
			key: "actual_date"
		},
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "stage"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		// {
		// 	name: "Assigned by",
		// 	key: "lead_advisor_full_name"
		// },
		// {
		// 	name: "Notified to",
		// 	key: "notified_to"
		// },
		{
			name: "Description",
			key: "description"
		},
	];

	assistant_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		// {
		// 	name: "Client Name",
		// 	key: "client_name"
		// },
		{
			name: "Activity Name",
			key: "name"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Actual Date",
			key: "actual_date"
		},
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "stage"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		// {
		// 	name: "Assigned by",
		// 	key: "lead_advisor_full_name"
		// },
		// {
		// 	name: "Notified to",
		// 	key: "notified_to"
		// },
		{
			name: "Description",
			key: "description"
		},
	];

	relationship_manager_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		// {
		// 	name: "Client Name",
		// 	key: "client_name"
		// },
		{
			name: "Activity Name",
			key: "name"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Actual Date",
			key: "actual_date"
		},
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "stage"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		// {
		// 	name: "Assigned by",
		// 	key: "lead_advisor_full_name"
		// },
		// {
		// 	name: "Notified to",
		// 	key: "notified_to"
		// },
		{
			name: "Description",
			key: "description"
		},
	];

	executive_manager_header: any = [
		// {
		// 	name: "Advisor Name",
		// 	key: "advisor_name"
		// },
		{
			name: "Activity Name",
			key: "name"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Status",
			key: "status_name"
		},
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		// {
		// 	name: "Stage",
		// 	key: "stage"
		// },
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Description",
			key: "description"
		}
	];

	// leadership_team_header: any = [
	// 	// {
	// 	// 	name: "Advisor Name",
	// 	// 	key: "advisor_name"
	// 	// },
	// 	{
	// 		name: "Activity Name",
	// 		key: "name"
	// 	},
	// 	// {
	// 	// 	name: "Type",
	// 	// 	key: "activity_type"
	// 	// },
	// 	{
	// 		name: "Status",
	// 		key: "status_name"
	// 	},
	// 	// {
	// 	// 	name: "Importance",
	// 	// 	key: "importance"
	// 	// },
	// 	{
	// 		name: "Scheduled Date",
	// 		key: "scheduled_date"
	// 	},
	// 	// {
	// 	// 	name: "Value/Opportunity",
	// 	// 	key: "opportunity"
	// 	// },
	// 	// {
	// 	// 	name: "Importance",
	// 	// 	key: "importance"
	// 	// },
	// 	// {
	// 	// 	name: "Status",
	// 	// 	key: "status_name"
	// 	// },
	// 	// {
	// 	// 	name: "Stage",
	// 	// 	key: "stage"
	// 	// },
	// 	// {
	// 	// 	name: "Type",
	// 	// 	key: "activity_type"
	// 	// },
	// 	{
	// 		name: "Description",
	// 		key: "description"
	// 	}
	// ];

	marketing_team_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		// {
		// 	name: "Client Name",
		// 	key: "client_name"
		// },
		{
			name: "Activity Name",
			key: "name"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Actual Date",
			key: "actual_date"
		},
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "stage"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		// {
		// 	name: "Assigned by",
		// 	key: "lead_advisor_full_name"
		// },
		// {
		// 	name: "Notified to",
		// 	key: "notified_to"
		// },
		{
			name: "Description",
			key: "description"
		},
	];

	wholesaler_header: any = [
		// {
		// 	name: "Advisor Name",
		// 	key: "advisor_name"
		// },
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Actual Date",
			key: "actual_date"
		},
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		// {
		// 	name: "Stage",
		// 	key: "stage"
		// },
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Description",
			key: "description"
		}
	];

  leadership_team_header: any = [
		// {
		// 	name: "Advisor Name",
		// 	key: "advisor_name"
		// },
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		{
			name: "Activity Name",
			key: "name"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Actual Date",
			key: "actual_date"
		},
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		// {
		// 	name: "Stage",
		// 	key: "stage"
		// },
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		{
			name: "Description",
			key: "description"
		}
	];

  lending_officer_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		// {
		// 	name: "Client Name",
		// 	key: "client_name"
		// },
		{
			name: "Activity Name",
			key: "name"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Actual Date",
			key: "actual_date"
		},
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "stage"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		// {
		// 	name: "Assigned by",
		// 	key: "lead_advisor_full_name"
		// },
		// {
		// 	name: "Notified to",
		// 	key: "notified_to"
		// },
		{
			name: "Description",
			key: "description"
		},
	];

  insurance_agent_header: any = [
		{
			name: "Campaigns",
			key: "campaigns"
		},
		{
			name: "Type",
			key: "activity_type"
		},
		{
			name: "Response",
			key: "response"
		},
		{
			name: "Status",
			key: "status_name"
		},
		{
			name: "Importance",
			key: "importance"
		},
		// {
		// 	name: "Client Name",
		// 	key: "client_name"
		// },
		{
			name: "Activity Name",
			key: "name"
		},
		// {
		// 	name: "Value/Opportunity",
		// 	key: "opportunity"
		// },
		// {
		// 	name: "Importance",
		// 	key: "importance"
		// },
		{
			name: "Scheduled Date",
			key: "scheduled_date"
		},
		{
			name: "Actual Date",
			key: "actual_date"
		},
		// {
		// 	name: "Status",
		// 	key: "status_name"
		// },
		{
			name: "Stage",
			key: "stage"
		},
		// {
		// 	name: "Type",
		// 	key: "activity_type"
		// },
		// {
		// 	name: "Assigned by",
		// 	key: "lead_advisor_full_name"
		// },
		// {
		// 	name: "Notified to",
		// 	key: "notified_to"
		// },
		{
			name: "Description",
			key: "description"
		},
	];

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
		private datePipe: DatePipe,
		private domSanitizer: DomSanitizer,
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
			this.activities_table_header = this.advisor_manager_header;
		} else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
			this.activities_table_header = this.advisor_header;
			if (this.selected_view_type != 'View') {
				this.activities_table_header.push({name: "Assigned to", key: "afa_name"});
				this.activities_table_header.push({name: "Notified by", key: "notified_by"});
			}
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
			this.activities_table_header = this.afa_header;
			if (this.selected_view_type != 'View') {
				this.activities_table_header.push({name: "Assigned to", key: "afa_name"});
				this.activities_table_header.push({name: "Notified by", key: "notified_by"});
			}
		} else if (this.user_details.role.role == 7) {
			this.user_role = "Assistant";
			this.activities_table_header = this.assistant_header;
			if (this.selected_view_type != 'View') {
				this.activities_table_header.push({name: "Assigned by", key: "lead_advisor_full_name"});
				this.activities_table_header.push({name: "Notified to", key: "notified_to"});
			}
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
			this.activities_table_header = this.relationship_manager_header;
			if (this.selected_view_type != 'View') {
				this.activities_table_header.push({name: "Assigned to", key: "afa_name"});
				this.activities_table_header.push({name: "Notified by", key: "notified_by"});
			}
		} else if (this.user_details.role.role == 3) {
			this.user_role = "Executive";
			this.activities_table_header = this.executive_manager_header;
		} else if (this.user_details.role.role == 10) {
			this.user_role = "Leadership";
			this.activities_table_header = this.leadership_team_header;
		} else if (this.user_details.role.role == 11) {
			this.user_role = "Marketing Team";
			this.activities_table_header = this.marketing_team_header;
		} else if (this.user_details.role.role == 12) {
			this.user_role = "Wholesaler";
			this.activities_table_header = this.wholesaler_header;
		} else if (this.user_details.role.role == 13) {
			this.user_role = "Lending Officer";
			this.activities_table_header = this.lending_officer_header;
		} else if (this.user_details.role.role == 14) {
			this.user_role = "Insurance Agent";
			this.activities_table_header = this.insurance_agent_header;
		}

		// else if (this.user_details.role.role == 11) {
		// 	this.user_role = "Marketing Team";
		// 	this.activities_table_header = this.marketing_team_header;
		// 	if (this.selected_view_type != 'View') {
		// 		this.activities_table_header.push({name: "Assigned to", key: "afa_name"});
		// 		this.activities_table_header.push({name: "Notified by", key: "notified_by"});
		// 	}
		// }

		this.getActivities(this.selected_user_data);

		if (this.selected_view_type != 'View') {

			// this.getTaskNames();

			// this.getStatusList();
			this.getConversionStatusList();
			// this.getCommunicationTypes();
			// this.getTaggingUsers();
			// this.getAFA();

			this.getProductList();
			this.getClientProductStatus();
			this.getAttritionReasons();

			// this.getStages();

		}
	}

	getKey(data, column) {
		const key = column['key'];
		if (data[key] && data[key] != "" && data[key] != null) {
			return data[key];
		} else {
			return "-";
		}

	}

	task_names_list: any = [];
	getTaskNames() {
		const user_data = this.storageService.get('user_details');
		this.commonService.getData("/taskName?user_type=" + user_data.role.role_name + "&no_page=true/").subscribe(
			(res: any) => {
				this.task_names_list = res;
			},
			(err) => {
				this.commonService.showToast("error", err.error);
			}
		)
	}

	activities: any = [];
	selected_activities: any = [];
	activities_loader: boolean = false;
	getActivities(client) {
		let route: any = "";
		if (this.user_role == "Advisor Manager") {
			route = "/advisormanageractivity/?advisor_manager=" + this.user_details.id + "&advisor=" + client.id + "&no_page=true&parent_task=true";

			if (this.selected_activity_type) {
				route = route + "&activity_type=" + this.selected_activity_type;
			}

			if (this.coaching_plan) {
				route = route + "&coaching_plan=" + this.coaching_plan.id;
			}

		} else if (this.user_role == "Executive") {
			route = "/internalactivity/?created_by=" + this.user_details.id + "&created_to=" + client.id + "&no_page=true&parent_task=true";

			if (this.selected_activity_type) {
				route = route + "&activity_type=" + this.selected_activity_type;
			}
		} else if (this.user_role == "Leadership") {
			// route = "/internalactivity/?created_by=" + this.user_details.id + "&created_to=" + client.id + "&no_page=true&parent_task=true";
      route = "/recruiteractivity?advisor=" + client.id + "&recruiter=" + this.user_details.id + "&no_page=true&parent_task=true";

			// if (this.selected_activity_type) {
			// 	route = route + "&activity_type=" + this.selected_activity_type;
			// }
		}  else if (this.user_role == "Wholesaler") {
			route = "/wholesaleractivity?advisor=" + client.id + "&wholesaler=" + this.user_details.id + "&no_page=true&parent_task=true";
		}
		// else if (this.user_role == "Marketing Team") {
		// 	route = "/internalactivity/?created_by=" + this.user_details.id + "&created_to=" + client.id + "&no_page=true&parent_task=true";

		// 	if (this.selected_activity_type) {
		// 		route = route + "&activity_type=" + this.selected_activity_type;
		// 	}
		// }
		 else {
			if ('is_client' in client) {
				route = "/leadprospectactivity?prospect=" + client.id + "&advisor=" + this.user_details.id + "&no_page=true&parent_task=true";
			} else {
				route = "/clientsalesactivity?client=" + client.id + "&advisor=" + this.user_details.id + "&no_page=true&parent_task=true";
			}

			if (this.user_details.role.role == 11) {
				if (client.type == 'members' || client.type == 'non_members') {
					route = route + "&business_area=6";
				} else {
					route = route + "&business_area=5";
				}
			} else if (this.user_details.role.role == 4 || this.user_details.role.role == 5) {
				route = route + "&business_area=5";
			} else if (this.user_details.role.role == 8) {
				route = route + "&business_area=6";
			} else if (this.user_details.role.role == 13) {
				route = route + "&business_area=7";
			} else if (this.user_details.role.role == 14) {
				route = route + "&business_area=8";
			}

			if (this.section_type) {
				if (this.section_type == "opportunity") {
					route = route + "&opportunity=true";
				} else if (this.section_type == "retention") {
					route = route + "&retention=true";
				} else if (this.section_type == "new") {
					route = route + "&new=true";
				} else if (this.section_type == "ai_assistant") {
					route = route + "&ai_assistant=true";
				}
			}

			if (this.stepper_stage) {
				if (this.stepper_stage.position == "first") {
					route = route + "&is_first=true&type=" + this.stepper_stage.type;
				}

			}
		}

		this.show_inner_view = null;
		this.show_more_options = null;
		this.activities_loader = true;
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.activities = res;
				this.activities_loader = false;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
				this.activities = [];
				this.activities_loader = false;
			},
		);
	}

	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
	}

	status_list: any = [];
	getStatusList() {
		this.commonService.getData('/status/?no_page=true').subscribe(
			(res: any) => {
				this.status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	conversion_status_list: any = [];
	getConversionStatusList() {
		this.commonService.getData('/conversionStatus/?no_page=true').subscribe(
			(res: any) => {
				this.conversion_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	communication_type_list: any = [];
	getCommunicationTypes() {
		this.commonService.getData('/communicationType/?no_page=true').subscribe(
			(res: any) => {
				this.communication_type_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	tagging_users_list: any = [];
	getTaggingUsers() {
		this.commonService.getData("/taguserslist/").subscribe(
			(res: any) => {
				this.tagging_users_list = res;
			},
			(err) => {
				this.commonService.showToast("error", err.error);
			}
		)
	}

	afa_list: any = [];
	getAFA() {
		this.commonService.getData('/getassistants').subscribe(
			(res: any) => {
				this.afa_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	financial_institution_branch_list: any = [];
	getFinancialInstitutionBranches() {
		this.commonService.getData('/financialinstitutionbranch?no_page=true&financial_institution=' + this.user_details.financial_institution).subscribe(
			(res: any) => {
				this.financial_institution_branch_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	product_list: any = [];
	getProductList() {
		this.commonService.getData('/product/?no_page=true&business_area=' + this.user_details.role.business_area[0]).subscribe(
			(res: any) => {
				this.product_list = res;
				this.getFinancialInstitutionBranches();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	client_product_status_list: any = [];
	getClientProductStatus() {
		this.commonService.getData('/clientProductStatus/?no_page=true').subscribe(
			(res: any) => {
				this.client_product_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	attrition_reasons_list: any = [];
	getAttritionReasons() {
		// let route = '/attritionreasons?financial_institution=' + this.user_details.financial_institution + '&no_page=true' + '&business_area=' + this.user_details.role.business_area[0];
		let route = '/attritionreasons?no_page=true' + '&business_area=' + this.user_details.role.business_area[0];
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.attrition_reasons_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	getProductType(id) {
		const index = this.product_list.findIndex((x) => x.id == id);
		if (index > -1) {
			this.product_data.product_type =
			this.product_list[index].product_type;
			if (this.product_list[index].product_type == 'Life Time') {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	}

	is_selected: boolean = false;
	selectAll(event) {
		if (event.checked == true) {
			this.selected_activities = JSON.parse(JSON.stringify(this.activities));
			this.is_selected = true;
		} else {
			this.selected_activities = [];
			this.is_selected = false;
		}
	}

	checkIndividualSelection(data) {
		const index = this.selected_activities.findIndex(
			(obj) => obj.id == data.id,
		);
		if (index != -1) {
			return true;
		} else {
			return false;
		}
	}

	selectIndividual(event, data) {
		const index = this.selected_activities.findIndex(
			(obj) => obj.id == data.id,
		);
		if (index != -1) {
			if (event.checked == true) {
				this.selected_activities.splice(index, 0, data);
			} else {
				this.selected_activities.splice(index, 1);
			}
		} else {
			this.selected_activities.splice(index, 0, data);
		}
		if (this.activities.length == this.selected_activities.length) {
			this.is_selected = true;
		} else {
			this.is_selected = false;
		}
	}

	show_inner_view: number = null;
	toggleActivityInnerView(value) {
		this.show_more_options = null;
		if (this.show_inner_view == value) {
			this.show_inner_view = null;
		} else {
			this.resetInnerViewData();
			this.resetDepositInnerViewData()
			this.show_inner_view = value;
		}
	}

	show_more_options: number = null;
	toggleActivityOptionsView(value) {
		this.show_inner_view = null;
		if (this.show_more_options == value) {
			this.show_more_options = null;
		} else {
			this.resetInnerViewData();
			this.resetDepositInnerViewData();
			this.show_more_options = value;
		}
	}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: any) {
		if (!((event.target.classList.contains("more-details-section")) || (event.target.classList.contains("more-details-icon")))) {
			this.show_more_options = null;
		}
	}

	@ViewChild('automatedActivitiesOperationModal') automatedActivitiesOperationModal: TemplateRef<any>;
	private automatedActivitiesOperationModalRef: MatDialogRef<TemplateRef<any>>;

	automated_activities_operation_type: any = "";
	openAutomatedActivityOperationModal(data, type) {
		this.automated_activities_operation_type = JSON.parse(JSON.stringify(type));
		if (this.automated_activities_operation_type == "Individual") {
			this.selected_activities = [];
			this.selected_activities.push(data);
		}
		this.automatedActivitiesOperationModalRef = this.dialog.open(this.automatedActivitiesOperationModal, { disableClose: true });
		this.automatedActivitiesOperationModalRef.afterClosed().subscribe((result) => {
			this.closeAutomatedActivityOperationModal();
		});
	}

	closeAutomatedActivityOperationModal() {
		this.automatedActivitiesOperationModalRef.close();
		this.selected_activities = [];
		this.automated_activities_operation_type = "";
		this.show_inner_view = null;
		this.show_more_options = null;
	}

	automatedActivityOperation() {
		let payload: any = {
			// client: this.selected_user_data.id,
			activity_ids: [],
			activity_paused: true
		};

		for (let index = 0; index < this.selected_activities.length; index++) {
			if (this.automated_activities_operation_type != "Individual") {
				if (this.selected_activities[index].activity_paused == false) {
					payload.activity_ids.push(this.selected_activities[index].id);
				}
			} else {
				payload.activity_ids.push(this.selected_activities[index].id);
			}
		}

		if (this.automated_activities_operation_type == "Individual") {
			payload.activity_paused = !this.selected_activities[0].activity_paused;
		}

		let route: any = "";
		if (this.user_role == "Advisor Manager") {
			route = "/advisormanageractivitystatuschange/";
		} else {
			if (this.selected_activities[0].user_type == 'Prospect') {
				route = "/leadactivitystatuschange/";
			} else if (this.selected_activities[0].user_type == 'Client') {
				route = "/clientactivitystatuschange/";
			}
		}

		this.commonService.postData(route, payload).subscribe(
			(res: any) => {
				if (this.automated_activities_operation_type == "Individual") {
					if (this.selected_activities[0].activity_paused == true) {
						this.commonService.showToast('success', "Activities have been Resumed");
					} else {
						this.commonService.showToast('success', "Activities have been Stopped");
					}
				} else {
					this.commonService.showToast('success', "Activities have been Stopped");
				}
				this.getActivities(this.selected_user_data);
				this.closeAutomatedActivityOperationModal();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	@ViewChild('activitiesDeleteModal') activitiesDeleteModal: TemplateRef<any>;
	private activitiesDeleteModalRef: MatDialogRef<TemplateRef<any>>;
	selected_activity_data: any;
	removeActivity(data) {
		this.selected_activity_data = data;
		this.activitiesDeleteModalRef = this.dialog.open(this.activitiesDeleteModal, { disableClose: true });
		this.activitiesDeleteModalRef.afterClosed().subscribe((result) => {
			this.closeDeleteActivityModal();
		});
	}

	closeDeleteActivityModal() {
		this.selected_activity_data = {};
		this.show_inner_view = null;
		this.show_more_options = null;
		this.activitiesDeleteModalRef.close();
	}

	deleteActivity() {
		let route: any = "";
		if (this.user_role == "Advisor Manager") {
			route = '/advisormanageractivity/';
		} else {
			if (this.selected_activity_data.source == 'csa') {
				route = "/clientsalesactivity/";
			} else if (this.selected_activity_data.source == 'lpa') {
				route = "/leadprospectactivity/";
			}
		}
		this.commonService.delete(route + 'destroy?ids=' + this.selected_activity_data.id,).subscribe(
			(res: any) => {
				this.getActivities(this.selected_user_data);
				this.closeDeleteActivityModal();
				this.commonService.showToast('success', 'Activity Deleted Successfully.');
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	captureResponseData(data, index, section) {
		this.toggleActivityInnerView(index);
		this.activity_opeartion_selected = "Capture Response";
		if (this.show_inner_view == index) {
			if (data.capture_response.captured_response) {
				this.capture_response_data = {
					response_status: data.capture_response.response_status,
					response_channel: data.capture_response.response_channel,
					response_capture_date: data.capture_response.response_capture_date,
					response_comments: data.capture_response.response_comments,
				};

				if (this.capture_response_data.response_capture_date != "" && this.capture_response_data.response_capture_date != null) {
					this.capture_response_data.response_capture_date = new Date(this.capture_response_data.response_capture_date);
				}
			}
		} else {
			this.activity_opeartion_selected = "";
		}

		this.show_more_options = null;

	}

	saveCaptureResponseData(data) {
		// if (this.validateCaptureResponse()) {
		// 	if (this.show_follow_up_task) {
		// 		if (this.validateActivityData()) {
		// 			this.saveResponse(data);
		// 			this.saveCaptureResponseActivityData();
		// 		}
		// 	} else {
		// 		this.saveResponse(data);
		// 	}
		// }


		let invalid_capture_response: boolean = false;
		let invalid_manual_activity: boolean = false;
		let invalid_conversion_status: boolean = false;
		let invalid_product_info: boolean = false;

		let invalid_stage_move_info: boolean = false;

		if (this.validateCaptureResponse()) {
			invalid_capture_response = false;
		} else {
			invalid_capture_response = true;
		}

		if (this.show_follow_up_task == true) {
			if (this.validateActivityData()) {
				invalid_manual_activity = false;
			} else {
				invalid_manual_activity = true;
			}
		}

		// if ((this.activities[this.show_inner_view].stage == 'Pitch(Sales)' || this.activities[this.show_inner_view].stage == 'Follow Up(Sales)')) {
		if ((this.activities[this.show_inner_view].activity_type == 1 || this.activities[this.show_inner_view].activity_type == 2)) {
			if (this.show_close_deal == true) {
				if (this.validateConversionStatus()) {
					invalid_conversion_status = false;
					if (this.conversion_status_data.conversion_status == 1) {
						// if (this.validateProductInformation()) {
						// 	invalid_product_info = false;
						// }
						if (this.user_details.role.business_area[0] == '5') {
							if (this.validateProductInformation()) {
								invalid_product_info = false;
							}
						}
						if (this.user_details.role.business_area[0] == '6') {
							if (this.validateDepositProductInformation()) {
								invalid_product_info = false;
							}
						}
						else {
							invalid_product_info = true;
						}
					}
				} else {
					invalid_conversion_status = true;
				}
			}
		}

		// if ((this.activities[this.show_inner_view].stage == 'Pitch(Retention)' || this.activities[this.show_inner_view].stage == 'Follow Up(Retention)')) {
		if ((this.activities[this.show_inner_view].activity_type == 3 || this.activities[this.show_inner_view].activity_type == 5)) {
			if (this.show_close_deal == true) {
				if (this.validateOutcomeStatus()) {
					invalid_conversion_status = false;
					if (this.outcome_data.attrition_status == 'Retained, Upside') {
						// if (this.validateProductInformation()) {
						// 	invalid_product_info = false;
						// }
						if (this.user_details.role.business_area[0] == '5') {
							if (this.validateProductInformation()) {
								invalid_product_info = false;
							}
						}
						if (this.user_details.role.business_area[0] == '6') {
							if (this.validateDepositProductInformation()) {
								invalid_product_info = false;
							}
						}

						else {
							invalid_product_info = true;
						}
					}
				} else {
					invalid_conversion_status = true;
				}
			}
		}

		if (this.show_stage_move == true) {
			if (this.validateMoveStage()) {
				invalid_stage_move_info = false;
			} else {
				invalid_stage_move_info = true;
			}
		}

		if (
			invalid_capture_response == false &&
			invalid_manual_activity == false &&
			invalid_conversion_status == false &&
			invalid_product_info == false &&
			invalid_stage_move_info == false
		) {
			this.saveResponse(data);

			if (this.show_follow_up_task == true) {
				this.saveCaptureResponseActivityData();
			}

			if (this.show_close_deal == true) {
				if ((this.activities[this.show_inner_view].activity_type == 1 || this.activities[this.show_inner_view].activity_type == 3)) {
					this.saveConversionStatusData(this.activities[this.show_inner_view]);
					if (this.conversion_status_data.conversion_status == 1) {
						// if (this.validateProductInformation()) {
						// 	this.saveProductInformation();
						// }
						if (this.user_details.role.business_area[0] == '5') {
							if (this.validateProductInformation()) {
								this.saveProductInformation();
							}
						}
						if (this.user_details.role.business_area[0] == '6') {
							if (this.validateDepositProductInformation()) {
								this.saveProductInformation();
							}
						}
					}
				}

				if ((this.activities[this.show_inner_view].activity_type == 3 || this.activities[this.show_inner_view].activity_type == 5)) {
					this.saveOutcomeStatusData(this.activities[this.show_inner_view]);
					if (this.outcome_data.attrition_status == 'Retained, Upside') {
						if (this.validateProductInformation() || this.validateDepositProductInformation()) {
							this.saveProductInformation();
						}

					}
				}

			}

			if (this.show_stage_move == true) {
				this.saveMoveStageData();
			}
		}

	}

	saveCaptureResponseActivityData() {
		let payload: any = {
			name: this.activity_data.name,
			description: this.activity_data.description,
			scheduled_date: moment(this.activity_data.scheduled_date).format(),
			actual_date: this.activity_data.actual_date != '' ? moment(this.activity_data.actual_date).format() : null,
			communication_type: this.activity_data.communication_type,
			status: this.activity_data.status,
			afa_id: this.activity_data.afa_id,
			afa_comments: this.activity_data.afa_comments,
			// activity_type: 2,
			// activity_type: this.selected_activity_type,
			advisor: this.user_details.id,
			// client: this.selected_user_data.id,
			// client: this.activities[this.show_inner_view].client,
		};

		if (this.user_role == "Advisor Manager") {
			payload.activity_type = this.selected_activity_type;
		} else {
			if ((this.selected_activity_type == 1 || this.selected_activity_type == 2)) {
				payload.activity_type = 2;
			} else if ((this.selected_activity_type == 3 || this.selected_activity_type == 5)) {
				payload.activity_type = 3;
			}
		}



		// if (!this.selected_user_data.is_client) {
		// 	payload.prospect = this.activities[this.show_inner_view].client;
		// } else {
		// 	payload.client = this.activities[this.show_inner_view].client;
		// }

		if ('is_client' in this.selected_user_data) {
			payload.prospect = this.activities[this.show_inner_view].client;
		} else {
			payload.client = this.activities[this.show_inner_view].client;
		}

		this.saveActivityDataDetails(payload);
	}

	capture_response_data: any = {
		response_status: "",
		response_channel: "",
		response_capture_date: "",
		response_comments: ""
	};
	capture_response_data_errors: any = {
		response_status: false,
		response_channel: false,
		response_capture_date: false,
		response_comments: false
	};

	validateCaptureResponse() {
		if (
			this.capture_response_data.response_status != '' &&
			this.capture_response_data.response_status != null
		) {
			this.capture_response_data_errors.response_status = false;
		} else {
			this.capture_response_data_errors.response_status = true;
		}

		if (
			this.capture_response_data.response_channel != '' &&
			this.capture_response_data.response_channel != null
		) {
			this.capture_response_data_errors.response_channel = false;
		} else {
			this.capture_response_data_errors.response_channel = true;
		}

		if (
			this.capture_response_data.response_capture_date != '' &&
			this.capture_response_data.response_capture_date != null
		) {
			this.capture_response_data_errors.response_capture_date = false;
		} else {
			this.capture_response_data_errors.response_capture_date = true;
		}

		if (
			this.capture_response_data.response_comments != '' &&
			this.capture_response_data.response_comments != null
		) {
			this.capture_response_data_errors.response_comments = false;
		} else {
			this.capture_response_data_errors.response_comments = true;
		}

		if (
			this.capture_response_data_errors.response_status == false &&
			this.capture_response_data_errors.response_channel == false &&
			this.capture_response_data_errors.response_capture_date == false &&
			this.capture_response_data_errors.response_comments == false
		) {
			return true;
		} else {
			return false;
		}
	}

	saveResponse(data) {
		let payload:any = {
			response_status: this.capture_response_data.response_status,
			response_channel: this.capture_response_data.response_channel,
			response_capture_date: moment(this.capture_response_data.response_capture_date).format(),
			response_comments: this.capture_response_data.response_comments,
			// client: this.selected_user_data.id,
			client: this.activities[this.show_inner_view].client,
		};

		if (data.source == 'csa') {
			payload.csa_id = data.id;
		} else if (data.source == 'lpa') {
			payload.lpa_id = data.id;
		} else if (data.source == 'ama') {
			payload.ama_id = data.id;
		}

		if (data.capture_response.captured_response == true) {
			payload.id = data.capture_response.id;
			this.commonService.patch('/taskResponse/' + data.capture_response.id + "/", payload).subscribe(
				(res: any) => {
					if (!this.show_follow_up_task) {
						// this.getActivities(this.selected_user_data);
						this.resetInnerViewData();
						this.resetDepositInnerViewData();
					}
					this.show_inner_view = null;
					this.commonService.showToast('success', 'Response Captured Successfully.');
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		} else {
			this.commonService.postData('/taskResponse/', payload).subscribe(
				(res: any) => {
					if (!this.show_follow_up_task) {
						this.getActivities(this.selected_user_data);
						this.resetInnerViewData();
						this.resetDepositInnerViewData();
					}
					this.show_inner_view = null;
					this.commonService.showToast('success', 'Response Captured Successfully.');
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

	}

	show_follow_up_task: boolean = false;

	activity_data: any = {
		name: "",
		description: "",
		scheduled_date: new Date(),
		actual_date: "",
		communication_type: "",
		status: "",
		afa_id: "",
		afa_comments: "",
	};
	activity_data_errors: any = {
		name: false,
		description: false,
		scheduled_date: false,
		actual_date: false,
		communication_type: false,
		status: false,
		afa_id: false,
		afa_comments: false,
	};
	activity_operation_type: any = "Add";

	activity_opeartion_selected: any = "";

	validateActivityData() {
		if ( this.activity_data.name != '' && this.activity_data.name != null) {
			this.activity_data_errors.name = false;
		} else {
			this.activity_data_errors.name = true;
		}

		if ( this.activity_data.scheduled_date != '' && this.activity_data.scheduled_date != null) {
			this.activity_data_errors.scheduled_date = false;
		} else {
			this.activity_data_errors.scheduled_date = true;
		}

		if ( this.activity_data.communication_type != '' && this.activity_data.communication_type != null) {
			this.activity_data_errors.communication_type = false;
		} else {
			this.activity_data_errors.communication_type = true;
		}

		if ( this.activity_data.status != '' && this.activity_data.status != null) {
			this.activity_data_errors.status = false;
			if (this.activity_data.status == 3) {
				if ( this.activity_data.actual_date != '' && this.activity_data.actual_date != null) {
					this.activity_data_errors.actual_date = false;
				} else {
					this.activity_data_errors.actual_date = true;
				}
			} else {
				this.activity_data_errors.actual_date = false;
			}
		} else {
			this.activity_data_errors.status = true;
		}

		// if (this.activity_data.afa_id != "" && this.activity_data.afa_id != null) {
		// 	this.activity_data_errors.afa_id = false;
		// } else {
		// 	this.activity_data_errors.afa_id = true;
		// }

		// if (this.activity_data.afa_comments != "" && this.activity_data.afa_comments != null) {
		// 	this.activity_data_errors.afa_comments = false;
		// } else {
		// 	this.activity_data_errors.afa_comments = true;
		// }

		if (
			this.activity_data_errors.name == false &&
			this.activity_data_errors.scheduled_date == false &&
			this.activity_data_errors.actual_date == false &&
			this.activity_data_errors.communication_type == false &&
			this.activity_data_errors.status == false
			// this.activity_data_errors.afa_id == false &&
			// this.activity_data_errors.afa_comments == false &&
		) {
			return true;
		} else {
			return false;
		}
	}

	saveTaskData() {
		if (this.validateActivityData()) {
			this.saveActivityData();
		}
	}


	saveActivityData() {
		let payload: any = {
			name: this.activity_data.name,
			description: this.activity_data.description,
			scheduled_date: moment(this.activity_data.scheduled_date).format(),
			actual_date: this.activity_data.actual_date != '' ? moment(this.activity_data.actual_date).format() : null,
			communication_type: this.activity_data.communication_type,
			status: this.activity_data.status,
			// afa_id: this.activity_data.afa_id,
			// afa_comments: this.activity_data.afa_comments,
		};

		payload.activity_type = this.selected_activity_type;

		if (this.user_role == "Advisor Manager") {
			// payload.activity_type = this.activities[this.show_inner_view].activity_type;
			if (!this.activities[this.show_inner_view]) {
				// payload.activity_type = this.selected_activity_type;
				payload.advisor = this.selected_user_data.id;
			} else {
				// payload.activity_type = this.activities[this.show_inner_view].activity_type;
				payload.advisor = this.activities[this.show_inner_view].advisor_id;
				payload.coaching_plan = this.activities[this.show_inner_view].coaching_plan;
			}
			payload.advisor_manager = this.user_details.id;
		} else {
			// payload.activity_type = this.activities[this.show_inner_view].activity_type;
			// payload.activity_type = 2;

			// payload.activity_type = this.selected_activity_type;

			payload.advisor = this.user_details.id;
			if (!this.activities[this.show_inner_view]) {
				if ('is_client' in this.selected_user_data) {
					payload.prospect = this.selected_user_data.id;
				} else {
					payload.client = this.selected_user_data.id;
				}
			} else {
				// payload.client = this.activities[this.show_inner_view].client;
				if (this.activities[this.show_inner_view].source == 'csa') {
					if (this.activities[this.show_inner_view].client) {
						payload.client = this.activities[this.show_inner_view].client;
					} else {
						payload.client = this.selected_user_data.id;
					}
				} else if (this.activities[this.show_inner_view].source == 'lpa') {
					if (this.activities[this.show_inner_view].client) {
						payload.prospect = this.activities[this.show_inner_view].client;
					} else {
						payload.prospect = this.selected_user_data.id;
					}
				}
			}

			if (!this.activities[this.show_inner_view]) {
				// payload.client = this.selected_user_data.id;
				if ('is_client' in this.selected_user_data) {
					payload.prospect = this.selected_user_data.id;
				} else {
					payload.client = this.selected_user_data.id;
				}
			} else {
				if (this.activities[this.show_inner_view].source == 'csa') {
					if (this.activities[this.show_inner_view].client) {
						payload.client = this.activities[this.show_inner_view].client;
					} else {
						payload.client = this.selected_user_data.id;
					}
				} else if (this.activities[this.show_inner_view].source == 'lpa') {
					if (this.activities[this.show_inner_view].client) {
						payload.prospect = this.activities[this.show_inner_view].client;
					} else {
						payload.prospect = this.selected_user_data.id;
					}
				}
			}
		}


		let invalid_capture_response: boolean = false;
		let invalid_manual_activity: boolean = false;
		let invalid_conversion_status: boolean = false;
		let invalid_product_info: boolean = false;

		if (this.show_capture_response == true) {
			if (this.validateCaptureResponse()) {
				invalid_capture_response = false;
			} else {
				invalid_capture_response = true;
			}
		}

		if (this.show_follow_up_task == true) {
			if (this.validateManualActivityData()) {
				invalid_manual_activity = false;

			} else {
				invalid_manual_activity = true;
			}
		}

		if (this.show_close_deal == true) {
			if (this.validateConversionStatus()) {
				invalid_conversion_status = false;
				if (this.conversion_status_data.conversion_status == 1) {
					if (this.validateProductInformation() || this.validateDepositProductInformation()) {
						invalid_product_info = false;
					} else {
						invalid_product_info = true;
					}
				}
			} else {
				invalid_conversion_status = true;
			}
		}

		if (
			invalid_capture_response == false &&
			invalid_manual_activity == false &&
			invalid_conversion_status == false &&
			invalid_product_info == false
		) {
			this.saveActivityDataDetails(payload);
		}

		// if (this.show_capture_response == true) {
		// 	if (this.validateCaptureResponse()) {
		// 		this.saveActivityDataDetails(payload);
		// 	}
		// } else {
		// 	this.saveActivityDataDetails(payload);
		// }
	}

	saveActivityDataDetails(payload) {
		let route: any = "";
		if (this.user_role == "Advisor Manager") {
			route = '/advisormanageractivity/';
		} else {
			if (!this.activities[this.show_inner_view]) {
				// route = "/clientsalesactivity/";
				if ('is_client' in this.selected_user_data) {
					route = "/leadprospectactivity/";
				} else {
					route = "/clientsalesactivity/";
				}
			} else {
				if (this.activities[this.show_inner_view].source == 'csa') {
					route = "/clientsalesactivity/";
				} else if (this.activities[this.show_inner_view].source == 'lpa') {
					route = "/leadprospectactivity/";
				}
			}
		}

		if (this.activity_operation_type == "Add") {
			if (this.coaching_plan) {
				payload.coaching_plan = this.coaching_plan.id;
			}
			this.commonService.postData(route, payload).subscribe(
				(res: any) => {
					if (this.validateCaptureResponse() && this.show_capture_response == true) {
						this.saveResponse(res);

						if (this.validateManualActivityData && this.show_follow_up_task == true) {
							this.saveManualActivityData();
						}

						if (this.validateConversionStatus() && this.show_close_deal == true) {
							this.saveConversionStatusData(res);
							if (this.conversion_status_data.conversion_status == 1) {
								if (this.validateProductInformation() || this.validateDepositProductInformation()) {
									this.saveProductInformation();
								}
							}
						}

					}
					this.getActivities(this.selected_user_data);
					this.resetInnerViewData();
					this.resetDepositInnerViewData();
					this.commonService.showToast('success', 'Activity Added Successfully.', );
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		} else if (this.activity_operation_type == "Edit") {
			payload.id = this.activity_data.id;

			if (this.coaching_plan) {
				payload.coaching_plan = this.coaching_plan.id;
			}
			this.commonService.updateData(route + payload.id + '/', payload).subscribe(
				(res: any) => {
					if (this.validateCaptureResponse() && this.show_capture_response == true) {
						this.saveResponse(res);

						if (this.validateManualActivityData && this.show_follow_up_task == true) {
							this.saveManualActivityData();
						}

						if (this.validateConversionStatus() && this.show_close_deal == true) {
							this.saveConversionStatusData(res);
							if (this.conversion_status_data.conversion_status == 1) {
								if (this.validateProductInformation() || this.validateDepositProductInformation()) {
									this.saveProductInformation();
								}
							}
						}

					}
					this.getActivities(this.selected_user_data);
					this.resetInnerViewData();
					this.resetDepositInnerViewData();
					this.commonService.showToast('success', 'Activity Updated Successfully.', );
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}

	resetActivityData() {
		this.show_follow_up_task = false;
		this.activity_data = {
			name: "",
			description: "",
			scheduled_date: new Date(),
			actual_date: "",
			communication_type: "",
			status: "",
			afa_id: "",
			afa_comments: "",
		};
		this.activity_data_errors = {
			name: false,
			description: false,
			scheduled_date: false,
			actual_date: false,
			communication_type: false,
			status: false,
			afa_id: false,
			afa_comments: false,
		};
		this.activity_operation_type = "Add";
	}


	resetInnerViewData() {
		// Capture Response Data
		this.capture_response_data = {
			response_status: "",
			response_channel: "",
			response_capture_date: "",
			response_comments: ""
		};
		this.capture_response_data_errors = {
			response_status: false,
			response_channel: false,
			response_capture_date: false,
			response_comments: false
		};

		// Higher Data
		this.show_inner_view = null;
		this.show_more_options = null;

		// Activity Data
		this.show_follow_up_task = false;
		this.activity_data = {
			name: "",
			description: "",
			scheduled_date: new Date(),
			actual_date: "",
			communication_type: "",
			status: "",
			afa_id: "",
			afa_comments: "",
		};
		this.activity_data_errors = {
			name: false,
			description: false,
			scheduled_date: false,
			actual_date: false,
			communication_type: false,
			status: false,
			afa_id: false,
			afa_comments: false,
		};
		this.activity_operation_type = "Add";

		this.activity_opeartion_selected = "";

		// Comment Data
		this.comment_data = {
			comment_date: "",
			description: "",
		};
		this.comment_data_errors = {
			comment_date: false,
			description: false,
		};
		this.comments_list = [];


		// Product Data
		this.show_close_deal = false;
		this.show_capture_response = false;
		this.conversion_status_data = {
			conversion_status: '',
			conversion_comments: '',
		};
		this.conversion_status_data_errors = {
			conversion_status: false,
			conversion_comments: false,
		};
		this.product_data = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
		};
		this.product_data_errors = {
			client_id: false,
			client_type: false,
			expected_aum: false,
			expected_closure_date: false,
			status: false,
			policy_number: false,
			aum: false,
			start_date: false,
			product: false,
			close_date: false,
			type: false,
			client_product_status: false,
		};
		this.product_operation_type = "Add";
		// Manual Activity Data
		// Activity Data
		this.manual_activity_data = {
			name: "",
			description: "",
			scheduled_date: new Date(),
			actual_date: "",
			communication_type: "",
			status: "",
			afa_id: "",
			afa_comments: "",
		};
		this.manual_activity_data_errors = {
			name: false,
			description: false,
			scheduled_date: false,
			actual_date: false,
			communication_type: false,
			status: false,
			afa_id: false,
			afa_comments: false,
		};

		// Outcome Data
		this.outcome_data = {
			attrition_status: '',
			attrition_comments: '',
		};
		this.outcome_data_errors = {
			attrition_status: false,
			attrition_comments: false,
		};

		// Move Stage Data
		this.show_stage_move = false;
		this.move_stage_data = {
			stage: '',
			activity_status: false,
		};
		this.move_stage_data_errors = {
			stage: false,
			activity_status: false,
		};
	}

	activityOpeartion(data, type, section, index) {
		this.activity_data = JSON.parse(JSON.stringify(data));
		this.activity_operation_type = type;
		this.activity_opeartion_selected = section;

		if (
			this.activity_data.scheduled_date != null &&
			this.activity_data.scheduled_date != ''
		) {
			this.activity_data.scheduled_date = new Date(this.activity_data.scheduled_date);
		} else {
			this.activity_data.scheduled_date = new Date();
		}

		if (
			this.activity_data.actual_date != null &&
			this.activity_data.actual_date != ''
		) {
			this.activity_data.actual_date = new Date(this.activity_data.actual_date);
		} else {
			this.activity_data.actual_date = "";
			// this.activity_data.actual_date = new Date();
		}

		this.show_inner_view = index;
		this.show_more_options = null;
	}

	saveActivityOperationData() {
		if (this.validateActivityData()) {
			this.saveActivityData();
		}
	}

	comment_data: any = {
		comment_date: "",
		description: "",
	};
	comment_data_errors: any = {
		comment_date: false,
		description: false,
	};
	comment_operation_type: any = "";
	openCommentsSection(activity, section, index) {
		this.activity_data = JSON.parse(JSON.stringify(activity));
		this.activity_opeartion_selected = section;
		this.show_inner_view = index;
		this.show_more_options = null;

		this.getComments();
	}

	comments_list: any = [];
	getComments() {
		let route: any = "";
		if (this.user_role == "Advisor Manager") {
			route = '/advisormanageractivitycomments/?advisormanageradvisor_activity=' + this.activities[this.show_inner_view].id;
		} else {
			if (this.activities[this.show_inner_view].source == 'csa') {
				route = "/clientsalesactivitycomments/?clientsales_activity=" + this.activities[this.show_inner_view].id;
			} else if (this.activities[this.show_inner_view].source == 'lpa') {
				route = "/leadprospectactivitycomments/?prospect_activity=" + this.activities[this.show_inner_view].id;
			}
		}

		this.commonService.getData(route + '&ordering=id&no_page=true',).subscribe(
			(comments: any) => {
				this.comments_list = comments;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	saveComment() {
		if (this.comment_data.comment_date != "" && this.comment_data.comment_date != null) {
			this.comment_data_errors.comment_date = false;
		} else {
			this.comment_data_errors.comment_date = true;
		}

		if (this.comment_data.description != "" && this.comment_data.description != null) {
			this.comment_data_errors.description = false;
		} else {
			this.comment_data_errors.description = true;
		}

		if (
			this.comment_data_errors.comment_date == false &&
			this.comment_data_errors.description == false
		) {
			let route: any = "";
			let payload: any = {
				comment_date: moment(this.comment_data.comment_date).format(),
				description: this.comment_data.description,
			};
			if (this.user_role == "Advisor Manager") {
				route = '/advisormanageractivitycomments/';

				payload.advisormanageradvisor_activity = this.activities[this.show_inner_view].id;
			} else {
				if (this.activities[this.show_inner_view].source == 'csa') {
					route = "/clientsalesactivitycomments/";
					payload.clientsales_activity = this.activities[this.show_inner_view].id;
				} else if (this.activities[this.show_inner_view].source == 'lpa') {
					route = "/leadprospectactivitycomments/";
					payload.prospect_activity = this.activities[this.show_inner_view].id;
				}
			}
			this.commonService.postData(route, payload).subscribe(
				(res: any) => {
					this.getComments();
					this.resetCommentData();
					this.commonService.showToast('success', 'Comment Added Successfully.');
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}

	deleteComment(comment) {
		let route: any = "";
		if (this.user_role == "Advisor Manager") {
			route = '/advisormanageractivitycomments/';
		} else {
			if (this.activities[this.show_inner_view].source == 'csa') {
				route = "/clientsalesactivitycomments/";
			} else if (this.activities[this.show_inner_view].source == 'lpa') {
				route = "/leadprospectactivitycomments/";
			}
		}
		this.commonService.delete(route + 'destroy/?ids=' + comment.id).subscribe(
			(res: any) => {
				this.getComments();
				this.resetCommentData();
				this.commonService.showToast('success', 'Comment Deleted Successfully.',);
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	resetCommentData() {
		this.comment_data = {
			comment_date: "",
			description: "",
		};
		this.comment_data_errors = {
			comment_date: false,
			description: false,
		};
		this.comment_operation_type = "";
		// this.show_inner_view = null;
		// this.show_more_options = null;
	}

	openAttachmentsSection(activity, section, index) {
		this.activity_data = JSON.parse(JSON.stringify(activity));
		this.activity_opeartion_selected = section;
		this.show_inner_view = index;
		this.show_more_options = null;

		this.getAttachments();
	}

	attachments_list: any = [];
	getAttachments() {
		let route: any = "/taskAttachment/?no_page=true";
		if (this.activity_data.source == 'csa') {
			route = route + "&csa_id=" + this.activity_data.id;
		} else if (this.activity_data.source == 'lpa') {
			route = route + "&lpa_id=" + this.activity_data.id;
		} else if (this.activity_data.source == 'ama') {
			route = route + "&ama_id=" + this.activity_data.id;
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.attachments_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	downloadAttachment(attachment) {
		window.open(environment.apiEndpoint + "/" + attachment.attachment_download_link, "_blank");
	}

	attachment_data: any = {
		attachment_filename: "",
		attachment_file: "",
		comments: "",
	};
	attachment_data_errors: any = {
		attachment_filename: false,
		attachment_file: false,
		comments: false
	};
	attachment_operation_type: any = "";

	openAttachmentOperation(data, type) {
		this.attachment_data = data;
		this.attachment_operation_type = type;
	}

	uploadAttachment(event) {
		this.attachment_data.attachment_file = event.target.files[0];
		this.attachment_data.attachment_filename = event.target.files[0].name;
	}

	saveAttachment() {
		if (this.attachment_data.attachment_filename != "" && this.attachment_data.attachment_filename != null) {
			this.attachment_data_errors.attachment_filename = false;
		} else {
			this.attachment_data_errors.attachment_filename = true;
		}

		if (this.attachment_data.comments != "" && this.attachment_data.comments != null) {
			this.attachment_data_errors.comments = false;
		} else {
			this.attachment_data_errors.comments = true;
		}

		if (
			this.attachment_data_errors.attachment_filename == false &&
			this.attachment_data_errors.comments == false
		) {
			let form_data: any = new FormData();

			form_data.append("attachment_filename", this.attachment_data.attachment_filename);
			form_data.append("comments", this.attachment_data.comments);

			if (typeof(this.attachment_data.attachment_file) != "string") {
				form_data.append("attachment_file", this.attachment_data.attachment_file);
			}

			if (this.activity_data.source == 'csa') {
				form_data.append("csa_id", this.activity_data.id);
			} else if (this.activity_data.source == 'lpa') {
				form_data.append("lpa_id", this.activity_data.id);
			} else if (this.activity_data.source == 'ama') {
				form_data.append("ama_id", this.activity_data.id);
			}

			if (this.attachment_operation_type == 'Add') {
				this.commonService.postData("/taskAttachment/", form_data).subscribe(
					(res: any) => {
						this.getAttachments();
						this.resetAttachmentData();
						this.commonService.showToast('success', 'Attachment Added Successfully.');
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			} else if (this.attachment_operation_type == 'Edit') {
				form_data.append("id", this.attachment_data.id);
				this.commonService.updateData("/taskAttachment/" + this.attachment_data.id + "/", form_data).subscribe(
					(res: any) => {
						this.getAttachments();
						this.resetAttachmentData();
						this.commonService.showToast('success', 'Attachment Updated Successfully.');
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			}

		}

	}

	@ViewChild('attachmentDeleteModal') attachmentDeleteModal: TemplateRef<any>;
	private attachmentDeleteModalRef: MatDialogRef<TemplateRef<any>>;
	removeAttachment(data, index) {
		this.attachment_data = data;
		this.attachmentDeleteModalRef = this.dialog.open(
			this.attachmentDeleteModal, { disableClose: true }
		);
		this.attachmentDeleteModalRef.afterClosed().subscribe((result) => {
			this.closeDeleteAttachmentModal();
		});
	}

	closeDeleteAttachmentModal() {
		this.attachmentDeleteModalRef.close();
		this.show_inner_view = null;
		this.show_more_options = null;
		this.resetAttachmentData();
	}

	deleteAttachment() {
		this.commonService.delete("/taskAttachment/" + 'destroy?ids=' + this.attachment_data.id).subscribe(
			(res: any) => {
				this.getAttachments();
				this.closeDeleteAttachmentModal();
				this.commonService.showToast('success', 'Attachment Deleted Successfully.');
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	resetAttachmentData() {
		this.attachment_data = {
			attachment_filename: "",
			attachment_file: "",
			comments: "",
		};
		this.attachment_data_errors = {
			attachment_filename: false,
			attachment_file: false,
			comments: false
		};
		this.attachment_operation_type = "";
	}

	inner_tab_selected: any = "Add Manual Task";

	show_close_deal: boolean = false;
	show_capture_response: boolean = false;

	conversion_status_data: any = {
		conversion_status: '',
		conversion_comments: '',
	};
	conversion_status_data_errors: any = {
		conversion_status: false,
		conversion_comments: false,
	};

	validateConversionStatus() {
		if (
			this.conversion_status_data.conversion_status != '' &&
			this.conversion_status_data.conversion_status != null
		) {
			this.conversion_status_data_errors.conversion_status = false;
		} else {
			this.conversion_status_data_errors.conversion_status = true;
		}

		if (
			this.conversion_status_data.conversion_comments != '' &&
			this.conversion_status_data.conversion_comments != null
		) {
			this.conversion_status_data_errors.conversion_comments = false;
		} else {
			this.conversion_status_data_errors.conversion_comments = true;
		}

		if (
			this.conversion_status_data_errors.conversion_status == false &&
			this.conversion_status_data_errors.conversion_comments == false
		) {
			if (this.conversion_status_data.conversion_status == 1) {
				// this.validateProductInformation();
				// return true;
				if (this.user_details.role.business_area[0] == '5') {
					this.validateProductInformation();
					return true;
				}
				if (this.user_details.role.business_area[0] == '6') {
					this.validateDepositProductInformation();
					return true;
				}

			} else {
				return true;
			}
		} else {
			return false;
		}
	}

	saveConversionStatusData(data) {
		let payload: any = {
			conversion_status_id: this.conversion_status_data.conversion_status,
			conversion_comments: this.conversion_status_data.conversion_comments,
			client_id: this.selected_user_data.id,
			// client_id: this.activities[this.show_inner_view].client,
		};

		if (!data) {
			payload.id = "";
			if ('is_client' in this.selected_user_data) {
				payload.user_type = "Prospect";
			}else{
				payload.user_type = "Client";
			}
		} else {
			if (data.source == 'csa') {
				payload.csa_id = data.id;
			} else if (data.source == 'lpa') {
				payload.lpa_id = data.id;
			} else if (data.source == 'ama') {
				payload.ama_id = data.id;
			}
		}

		this.commonService.postData('/captureclientconversionstatus/', payload).subscribe(
			(res: any) => {
				this.getActivities(this.selected_user_data)
				this.resetInnerViewData();
				this.resetDepositInnerViewData();
				this.commonService.showToast('success','Conversion Status Changed Successfully.',);
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	product_data: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		financial_institution_branch: '',
		deposit_purpose: '',
	};
	product_data_errors: any = {
		client_id: false,
		client_type: false,
		expected_aum: false,
		expected_closure_date: false,
		status: false,
		policy_number: false,
		aum: false,
		start_date: false,
		product: false,
		close_date: false,
		type: false,
		client_product_status: false,
		financial_institution_branch: false,
		deposit_purpose: false,
	};
	product_operation_type: any = "Add";
	validateProductInformation() {
		if (
			this.product_data.policy_number != '' &&
			this.product_data.policy_number != null
		) {
			this.product_data_errors.policy_number = false;
		} else {
			this.product_data_errors.policy_number = true;
		}

		if (
			this.product_data.aum != '' &&
			this.product_data.aum != null
		) {
			this.product_data_errors.aum = false;
		} else {
			this.product_data_errors.aum = true;
		}

		if (
			this.product_data.start_date != '' &&
			this.product_data.start_date != null
		) {
			this.product_data_errors.start_date = false;
		} else {
			this.product_data_errors.start_date = true;
		}

		if (
			this.product_data.product != '' &&
			this.product_data.product != null
		) {
			this.product_data_errors.product = false;
		} else {
			this.product_data_errors.product = true;
		}

		// if (this.product_data.close_date != "" && this.product_data.close_date != null) {
		//   this.product_data_errors.close_date = false;
		// } else {
		//   this.product_data_errors.close_date = true;
		// }

		if (
			this.product_data.product_type == 'Life Time' ||
			(this.product_data.close_date != '' &&
				this.product_data.close_date != null)
			) {
				this.product_data_errors.close_date = false;
			} else {
				this.product_data_errors.close_date = true;
			}

			if (
				this.product_data.type != '' &&
				this.product_data.type != null
			) {
				this.product_data_errors.type = false;
			} else {
				this.product_data_errors.type = true;
			}

			if (
				this.product_data.client_product_status != '' &&
				this.product_data.client_product_status != null
			) {
				this.product_data_errors.client_product_status = false;
			} else {
				this.product_data_errors.client_product_status = true;
			}

			if (
				this.product_data.financial_institution_branch != '' &&
				this.product_data.financial_institution_branch != null
			) {
				this.product_data_errors.financial_institution_branch = false;
			} else {
				this.product_data_errors.financial_institution_branch = true;
			}

			if (this.user_role == "Relationship Manager") {
				if (
					this.product_data.deposit_purpose != '' &&
					this.product_data.deposit_purpose != null
				) {
					this.product_data_errors.deposit_purpose = false;
				} else {
					this.product_data_errors.deposit_purpose = true;
				}
			} else {
				this.product_data.deposit_purpose = "";
				this.product_data_errors.deposit_purpose = false;
			}

			if (
				this.product_data_errors.policy_number == false &&
				this.product_data_errors.aum == false &&
				this.product_data_errors.start_date == false &&
				this.product_data_errors.product == false &&
				this.product_data_errors.close_date == false &&
				this.product_data_errors.type == false &&
				this.product_data_errors.client_product_status == false &&
				this.product_data_errors.financial_institution_branch == false &&
				this.product_data_errors.deposit_purpose == false
			) {
				return true;
			} else {
				return false;
			}
		}


		depositProduct_data: any = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			financial_institution_branch: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',

		};
		depositProduct_data_errors: any = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			financial_institution_branch: false,
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',
		};

		depositProduct_operation_type: any = "Add";
		validateDepositProductInformation() {
			if (
				this.depositProduct_data.policy_number != '' &&
				this.depositProduct_data.policy_number != null
			) {
				this.depositProduct_data_errors.policy_number = false;
			} else {
				this.depositProduct_data_errors.policy_number = true;
			}

			if (
				this.depositProduct_data.aum != '' &&
				this.depositProduct_data.aum != null
			) {
				this.depositProduct_data_errors.aum = false;
			} else {
				this.depositProduct_data_errors.aum = true;
			}

			if (
				this.depositProduct_data.start_date != '' &&
				this.depositProduct_data.start_date != null
			) {
				this.depositProduct_data_errors.start_date = false;
			} else {
				this.depositProduct_data_errors.start_date = true;
			}

			if (
				this.depositProduct_data.product != '' &&
				this.depositProduct_data.product != null
			) {
				this.depositProduct_data_errors.product = false;
			} else {
				this.depositProduct_data_errors.product = true;
			}

			if (this.depositProduct_data.close_date != "" && this.depositProduct_data.close_date != null) {
				this.depositProduct_data_errors.close_date = false;
			} else {
				this.depositProduct_data_errors.close_date = true;
			}

			if (
				this.depositProduct_data.product_type == 'Life Time' ||
				(this.depositProduct_data.close_date != '' &&
					this.depositProduct_data.close_date != null)
				) {
					this.depositProduct_data_errors.close_date = false;
				} else {
					this.depositProduct_data_errors.close_date = true;
				}

				if (
					this.depositProduct_data.type != '' &&
					this.depositProduct_data.type != null
				) {
					this.depositProduct_data_errors.type = false;
				} else {
					this.depositProduct_data_errors.type = true;
				}


				if (
					this.depositProduct_data.interest_rate != '' &&
					this.depositProduct_data.interest_rate != null
				) {
					this.depositProduct_data_errors.interest_rate = false;
				} else {
					this.depositProduct_data_errors.interest_rate = true;
				}

				if (
					this.depositProduct_data.monthly_fees != '' &&
					this.depositProduct_data.monthly_fees != null
				) {
					this.depositProduct_data_errors.monthly_fees = false;
				} else {
					this.depositProduct_data_errors.monthly_fees = true;
				}

				if (
					this.depositProduct_data.client_product_status != '' &&
					this.depositProduct_data.client_product_status != null
				) {
					this.depositProduct_data_errors.client_product_status = false;
				} else {
					this.depositProduct_data_errors.client_product_status = true;
				}

				if (
					this.depositProduct_data.financial_institution_branch != '' &&
					this.depositProduct_data.financial_institution_branch != null
				) {
					this.depositProduct_data_errors.financial_institution_branch = false;
				} else {
					this.depositProduct_data_errors.financial_institution_branch = true;
				}

				// if (this.user_role == "Relationship Manager") {
				// 	if (
				// 		this.depositProduct_data.deposit_purpose != '' &&
				// 		this.depositProduct_data.deposit_purpose != null
				// 	) {
				// 		this.depositProduct_data_errors.deposit_purpose = false;
				// 	} else {
				// 		this.depositProduct_data_errors.deposit_purpose = true;
				// 	}
				// }
				// else {
				// 	this.depositProduct_data.deposit_purpose = "";
				// 	this.depositProduct_data_errors.deposit_purpose = false;
				// }

				if (
					this.depositProduct_data_errors.policy_number == false &&
					this.depositProduct_data_errors.aum == false &&
					this.depositProduct_data_errors.start_date == false &&
					this.depositProduct_data_errors.product == false &&
					this.depositProduct_data_errors.close_date == false &&
					this.depositProduct_data_errors.type == false &&
					this.depositProduct_data_errors.client_product_status == false &&
					this.depositProduct_data_errors.financial_institution_branch == false &&
					this.depositProduct_data_errors.interest_rate == false &&
					this.depositProduct_data_errors.monthly_fees == false &&
					this.min_amount_error == false
					// this.depositProduct_data_errors.deposit_purpose == false
				) {
					return true;
				} else {
					return false;
				}
			}


			resetDepositInnerViewData() {
				this.conversion_status_data = {
					conversion_status: '',
					conversion_comments: '',
				};
				this.conversion_status_data_errors = {
					conversion_status: false,
					conversion_comments: false,
				};
				this.depositProduct_data = {
					client_id: '',
					client_type: '',
					expected_aum: '',
					expected_closure_date: '',
					status: '',
					policy_number: '',
					aum: '',
					start_date: '',
					product: '',
					close_date: '',
					type: '',
					client_product_status: '',
					financial_institution_branch: '',
					deposit_purpose: '',
					interest_rate: '',
					monthly_fees: '',

				};
				this.depositProduct_data_errors = {
					client_id: '',
					client_type: '',
					expected_aum: '',
					expected_closure_date: '',
					status: '',
					policy_number: '',
					aum: '',
					start_date: '',
					product: '',
					close_date: '',
					type: '',
					client_product_status: '',
					financial_institution_branch: '',
					deposit_purpose: '',
					interest_rate: '',
					monthly_fees: '',
				};
				this.depositProduct_operation_type = "Add";

				this.outcome_data = {
					attrition_status: '',
					attrition_comments: '',
				};
				this.outcome_data_errors = {
					attrition_status: false,
					attrition_comments: false,
				};
			}

      lending_product_data: any = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			financial_institution_branch: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',

		};
		lending_product_data_errors: any = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			financial_institution_branch: false,
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',
		};

		lending_product_operation_type: any = "Add";
		validateLendingProductInformation() {
			if (
				this.lending_product_data.policy_number != '' &&
				this.lending_product_data.policy_number != null
			) {
				this.lending_product_data_errors.policy_number = false;
			} else {
				this.lending_product_data_errors.policy_number = true;
			}

			if (
				this.lending_product_data.aum != '' &&
				this.lending_product_data.aum != null
			) {
				this.lending_product_data_errors.aum = false;
			} else {
				this.lending_product_data_errors.aum = true;
			}

			if (
				this.lending_product_data.start_date != '' &&
				this.lending_product_data.start_date != null
			) {
				this.lending_product_data_errors.start_date = false;
			} else {
				this.lending_product_data_errors.start_date = true;
			}

			if (
				this.lending_product_data.product != '' &&
				this.lending_product_data.product != null
			) {
				this.lending_product_data_errors.product = false;
			} else {
				this.lending_product_data_errors.product = true;
			}

			if (this.lending_product_data.close_date != "" && this.lending_product_data.close_date != null) {
				this.lending_product_data_errors.close_date = false;
			} else {
				this.lending_product_data_errors.close_date = true;
			}

			if (
				this.lending_product_data.product_type == 'Life Time' ||
				(this.lending_product_data.close_date != '' &&
					this.lending_product_data.close_date != null)
				) {
					this.lending_product_data_errors.close_date = false;
				} else {
					this.lending_product_data_errors.close_date = true;
				}

				if (
					this.lending_product_data.type != '' &&
					this.lending_product_data.type != null
				) {
					this.lending_product_data_errors.type = false;
				} else {
					this.lending_product_data_errors.type = true;
				}


				if (
					this.lending_product_data.interest_rate != '' &&
					this.lending_product_data.interest_rate != null
				) {
					this.lending_product_data_errors.interest_rate = false;
				} else {
					this.lending_product_data_errors.interest_rate = true;
				}

				if (
					this.lending_product_data.monthly_fees != '' &&
					this.lending_product_data.monthly_fees != null
				) {
					this.lending_product_data_errors.monthly_fees = false;
				} else {
					this.lending_product_data_errors.monthly_fees = true;
				}

				if (
					this.lending_product_data.client_product_status != '' &&
					this.lending_product_data.client_product_status != null
				) {
					this.lending_product_data_errors.client_product_status = false;
				} else {
					this.lending_product_data_errors.client_product_status = true;
				}

				if (
					this.lending_product_data.financial_institution_branch != '' &&
					this.lending_product_data.financial_institution_branch != null
				) {
					this.lending_product_data_errors.financial_institution_branch = false;
				} else {
					this.lending_product_data_errors.financial_institution_branch = true;
				}

				// if (this.user_role == "Relationship Manager") {
				// 	if (
				// 		this.lending_product_data.deposit_purpose != '' &&
				// 		this.lending_product_data.deposit_purpose != null
				// 	) {
				// 		this.lending_product_data_errors.deposit_purpose = false;
				// 	} else {
				// 		this.lending_product_data_errors.deposit_purpose = true;
				// 	}
				// }
				// else {
				// 	this.lending_product_data.deposit_purpose = "";
				// 	this.lending_product_data_errors.deposit_purpose = false;
				// }

				if (
					this.lending_product_data_errors.policy_number == false &&
					this.lending_product_data_errors.aum == false &&
					this.lending_product_data_errors.start_date == false &&
					this.lending_product_data_errors.product == false &&
					this.lending_product_data_errors.close_date == false &&
					this.lending_product_data_errors.type == false &&
					this.lending_product_data_errors.client_product_status == false &&
					this.lending_product_data_errors.financial_institution_branch == false &&
					this.lending_product_data_errors.interest_rate == false &&
					this.lending_product_data_errors.monthly_fees == false &&
					this.min_amount_error == false
					// this.lending_product_data_errors.deposit_purpose == false
				) {
					return true;
				} else {
					return false;
				}
			}


			resetLendingInnerViewData() {
				this.conversion_status_data = {
					conversion_status: '',
					conversion_comments: '',
				};
				this.conversion_status_data_errors = {
					conversion_status: false,
					conversion_comments: false,
				};
				this.lending_product_data = {
					client_id: '',
					client_type: '',
					expected_aum: '',
					expected_closure_date: '',
					status: '',
					policy_number: '',
					aum: '',
					start_date: '',
					product: '',
					close_date: '',
					type: '',
					client_product_status: '',
					financial_institution_branch: '',
					deposit_purpose: '',
					interest_rate: '',
					monthly_fees: '',

				};
				this.lending_product_data_errors = {
					client_id: '',
					client_type: '',
					expected_aum: '',
					expected_closure_date: '',
					status: '',
					policy_number: '',
					aum: '',
					start_date: '',
					product: '',
					close_date: '',
					type: '',
					client_product_status: '',
					financial_institution_branch: '',
					deposit_purpose: '',
					interest_rate: '',
					monthly_fees: '',
				};
				this.lending_product_operation_type = "Add";

				this.outcome_data = {
					attrition_status: '',
					attrition_comments: '',
				};
				this.outcome_data_errors = {
					attrition_status: false,
					attrition_comments: false,
				};
			}

      insurance_product_data: any = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			financial_institution_branch: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',

		};
		insurance_product_data_errors: any = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			financial_institution_branch: false,
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',
		};

		insurance_product_operation_type: any = "Add";
		validateInsuranceProductInformation() {
			if (
				this.insurance_product_data.policy_number != '' &&
				this.insurance_product_data.policy_number != null
			) {
				this.insurance_product_data_errors.policy_number = false;
			} else {
				this.insurance_product_data_errors.policy_number = true;
			}

			if (
				this.insurance_product_data.aum != '' &&
				this.insurance_product_data.aum != null
			) {
				this.insurance_product_data_errors.aum = false;
			} else {
				this.insurance_product_data_errors.aum = true;
			}

			if (
				this.insurance_product_data.start_date != '' &&
				this.insurance_product_data.start_date != null
			) {
				this.insurance_product_data_errors.start_date = false;
			} else {
				this.insurance_product_data_errors.start_date = true;
			}

			if (
				this.insurance_product_data.product != '' &&
				this.insurance_product_data.product != null
			) {
				this.insurance_product_data_errors.product = false;
			} else {
				this.insurance_product_data_errors.product = true;
			}

			if (this.insurance_product_data.close_date != "" && this.insurance_product_data.close_date != null) {
				this.insurance_product_data_errors.close_date = false;
			} else {
				this.insurance_product_data_errors.close_date = true;
			}

			if (
				this.insurance_product_data.product_type == 'Life Time' ||
				(this.insurance_product_data.close_date != '' &&
					this.insurance_product_data.close_date != null)
				) {
					this.insurance_product_data_errors.close_date = false;
				} else {
					this.insurance_product_data_errors.close_date = true;
				}

				if (
					this.insurance_product_data.type != '' &&
					this.insurance_product_data.type != null
				) {
					this.insurance_product_data_errors.type = false;
				} else {
					this.insurance_product_data_errors.type = true;
				}


				if (
					this.insurance_product_data.interest_rate != '' &&
					this.insurance_product_data.interest_rate != null
				) {
					this.insurance_product_data_errors.interest_rate = false;
				} else {
					this.insurance_product_data_errors.interest_rate = true;
				}

				if (
					this.insurance_product_data.monthly_fees != '' &&
					this.insurance_product_data.monthly_fees != null
				) {
					this.insurance_product_data_errors.monthly_fees = false;
				} else {
					this.insurance_product_data_errors.monthly_fees = true;
				}

				if (
					this.insurance_product_data.client_product_status != '' &&
					this.insurance_product_data.client_product_status != null
				) {
					this.insurance_product_data_errors.client_product_status = false;
				} else {
					this.insurance_product_data_errors.client_product_status = true;
				}

				if (
					this.insurance_product_data.financial_institution_branch != '' &&
					this.insurance_product_data.financial_institution_branch != null
				) {
					this.insurance_product_data_errors.financial_institution_branch = false;
				} else {
					this.insurance_product_data_errors.financial_institution_branch = true;
				}

				// if (this.user_role == "Relationship Manager") {
				// 	if (
				// 		this.insurance_product_data.deposit_purpose != '' &&
				// 		this.insurance_product_data.deposit_purpose != null
				// 	) {
				// 		this.insurance_product_data_errors.deposit_purpose = false;
				// 	} else {
				// 		this.insurance_product_data_errors.deposit_purpose = true;
				// 	}
				// }
				// else {
				// 	this.insurance_product_data.deposit_purpose = "";
				// 	this.insurance_product_data_errors.deposit_purpose = false;
				// }

				if (
					this.insurance_product_data_errors.policy_number == false &&
					this.insurance_product_data_errors.aum == false &&
					this.insurance_product_data_errors.start_date == false &&
					this.insurance_product_data_errors.product == false &&
					this.insurance_product_data_errors.close_date == false &&
					this.insurance_product_data_errors.type == false &&
					this.insurance_product_data_errors.client_product_status == false &&
					this.insurance_product_data_errors.financial_institution_branch == false &&
					this.insurance_product_data_errors.interest_rate == false &&
					this.insurance_product_data_errors.monthly_fees == false &&
					this.min_amount_error == false
					// this.insurance_product_data_errors.deposit_purpose == false
				) {
					return true;
				} else {
					return false;
				}
			}


			resetInsuranceInnerViewData() {
				this.conversion_status_data = {
					conversion_status: '',
					conversion_comments: '',
				};
				this.conversion_status_data_errors = {
					conversion_status: false,
					conversion_comments: false,
				};
				this.insurance_product_data = {
					client_id: '',
					client_type: '',
					expected_aum: '',
					expected_closure_date: '',
					status: '',
					policy_number: '',
					aum: '',
					start_date: '',
					product: '',
					close_date: '',
					type: '',
					client_product_status: '',
					financial_institution_branch: '',
					deposit_purpose: '',
					interest_rate: '',
					monthly_fees: '',

				};
				this.insurance_product_data_errors = {
					client_id: '',
					client_type: '',
					expected_aum: '',
					expected_closure_date: '',
					status: '',
					policy_number: '',
					aum: '',
					start_date: '',
					product: '',
					close_date: '',
					type: '',
					client_product_status: '',
					financial_institution_branch: '',
					deposit_purpose: '',
					interest_rate: '',
					monthly_fees: '',
				};
				this.insurance_product_operation_type = "Add";

				this.outcome_data = {
					attrition_status: '',
					attrition_comments: '',
				};
				this.outcome_data_errors = {
					attrition_status: false,
					attrition_comments: false,
				};
			}

			saveProductInformation() {
				let payload: any ;
				if (this.user_details.role.business_area[0] == '5'){
					payload = {
						product: this.product_data.product,
						policy_number: this.product_data.policy_number,
						aum: this.product_data.aum == '' ? 0 : this.product_data.aum,
						start_date: moment(this.product_data.start_date).format(),
						close_date: this.product_data.close_date != '' ? moment(this.product_data.close_date).format() : null,
						// client: this.selected_user_data.id,
						// client: this.activities[this.show_inner_view].client,
						type: this.product_data.type,
						client_product_status: this.product_data.client_product_status,
						financial_institution_branch: this.product_data.financial_institution_branch,
						deposit_purpose: this.product_data.deposit_purpose,
					};
				}
				if (this.user_details.role.business_area[0] == '6') {
					payload = {
						product: this.depositProduct_data.product,
						policy_number: this.depositProduct_data.policy_number,
						aum: this.depositProduct_data.aum == '' ? 0 : this.depositProduct_data.aum,
						start_date: moment(this.depositProduct_data.start_date).format(),
						close_date: this.depositProduct_data.close_date != '' ? moment(this.depositProduct_data.close_date).format() : null,
						// client: this.selected_user_data.id,
						// client: this.activities[this.show_inner_view].client,
						type: this.depositProduct_data.type,
						client_product_status: this.depositProduct_data.client_product_status,
						financial_institution_branch: this.depositProduct_data.financial_institution_branch,
						deposit_purpose: this.depositProduct_data.deposit_purpose,
						interest_rate: this.depositProduct_data.interest_rate,
						monthly_fees: this.depositProduct_data.monthly_fees,

					};
				}

        if (this.user_details.role.business_area[0] == '7') {
					payload = {
						product: this.lending_product_data.product,
						policy_number: this.lending_product_data.policy_number,
						aum: this.lending_product_data.aum == '' ? 0 : this.lending_product_data.aum,
						start_date: moment(this.lending_product_data.start_date).format(),
						close_date: this.lending_product_data.close_date != '' ? moment(this.lending_product_data.close_date).format() : null,
						// client: this.selected_user_data.id,
						// client: this.activities[this.show_inner_view].client,
						type: this.lending_product_data.type,
						client_product_status: this.lending_product_data.client_product_status,
						financial_institution_branch: this.lending_product_data.financial_institution_branch,
						deposit_purpose: this.lending_product_data.deposit_purpose,
						interest_rate: this.lending_product_data.interest_rate,
						monthly_fees: this.lending_product_data.monthly_fees,

					};
				}

        if (this.user_details.role.business_area[0] == '8') {
					payload = {
						product: this.insurance_product_data.product,
						policy_number: this.insurance_product_data.policy_number,
						aum: this.insurance_product_data.aum == '' ? 0 : this.insurance_product_data.aum,
						start_date: moment(this.insurance_product_data.start_date).format(),
						close_date: this.insurance_product_data.close_date != '' ? moment(this.insurance_product_data.close_date).format() : null,
						// client: this.selected_user_data.id,
						// client: this.activities[this.show_inner_view].client,
						type: this.insurance_product_data.type,
						client_product_status: this.insurance_product_data.client_product_status,
						financial_institution_branch: this.insurance_product_data.financial_institution_branch,
						deposit_purpose: this.insurance_product_data.deposit_purpose,
						interest_rate: this.insurance_product_data.interest_rate,
						monthly_fees: this.insurance_product_data.monthly_fees,

					};
				}


				if (this.stepper_stage) {
					payload.stepper_type = this.stepper_stage.type;
				}


				if (this.product_operation_type == "Add") {
					let route: any = "";
					if (this.activities[this.show_inner_view]) {
						if (this.activities[this.show_inner_view].source == 'csa') {
							route = "/addclientinvestedproducts/";
							payload.client = this.selected_user_data.id;
						} else if (this.activities[this.show_inner_view].source == 'lpa') {
							route = "/addprospectinvestedproducts/";
							payload.prospect = this.selected_user_data.id;
						}
					} else {
						if ('is_client' in this.selected_user_data) {
							route = "/addprospectinvestedproducts/";
							payload.prospect = this.selected_user_data.id;
						} else {
							route = "/addclientinvestedproducts/";
							payload.client = this.selected_user_data.id;
						}
					}
					this.commonService.postData(route, payload).subscribe(
						(res: any) => {
							// this.saveConversionStatusData();
							this.getActivities(this.selected_user_data)
							this.resetInnerViewData();
							this.resetDepositInnerViewData();
              this.resetLendingInnerViewData();
              this.resetInsuranceInnerViewData();
							this.commonService.showToast('success', 'Product Added Successfully.',);
							this.clientStageChanged();
						},
						(err) => {
							this.commonService.showToast('error', err.error);
						},
					);
				}

				else if (this.product_operation_type == "Edit") {
					if (this.user_details.role.business_area[0] == '5') {
						payload.id = this.product_data.id;
					} else if (this.user_details.role.business_area[0] == '6') {
						payload.id = this.depositProduct_data.id;
					} else if (this.user_details.role.business_area[0] == '7') {
						payload.id = this.lending_product_data.id;
					} else if (this.user_details.role.business_area[0] == '8') {
						payload.id = this.insurance_product_data.id;
					}
					let route: any = "";

					// if (this.activities[this.show_inner_view].source == 'csa') {
					// 	route = "/clientproducts/";
					// } else if (this.activities[this.show_inner_view].source == 'lpa') {
					// 	route = "/prospectinvestedproducts/";
					// }

					route = "/clientproducts/";

					this.commonService.updateData(route + payload.id + '/', payload).subscribe(
						(res: any) => {
							this.getClientProducts(this.selected_user_data);
							this.resetInnerViewData();
							this.resetDepositInnerViewData();
              this.resetLendingInnerViewData();
              this.resetInsuranceInnerViewData();
							this.commonService.showToast('success', 'Product Updated Successfully.', );

							this.clientStageChanged();
						},
						(err) => {
							this.commonService.showToast('error', err.error);
						},
					);
				}
			}

			manual_activity_data: any = {
				name: "",
				description: "",
				scheduled_date: new Date(),
				actual_date: "",
				communication_type: "",
				status: "",
				afa_id: "",
				afa_comments: "",
			};
			manual_activity_data_errors: any = {
				name: false,
				description: false,
				scheduled_date: false,
				actual_date: false,
				communication_type: false,
				status: false,
				afa_id: false,
				afa_comments: false,
			};

			validateManualActivityData() {
				if ( this.manual_activity_data.name != '' && this.manual_activity_data.name != null) {
					this.manual_activity_data_errors.name = false;
				} else {
					this.manual_activity_data_errors.name = true;
				}

				if ( this.manual_activity_data.scheduled_date != '' && this.manual_activity_data.scheduled_date != null) {
					this.manual_activity_data_errors.scheduled_date = false;
				} else {
					this.manual_activity_data_errors.scheduled_date = true;
				}

				if ( this.manual_activity_data.communication_type != '' && this.manual_activity_data.communication_type != null) {
					this.manual_activity_data_errors.communication_type = false;
				} else {
					this.manual_activity_data_errors.communication_type = true;
				}

				if ( this.manual_activity_data.status != '' && this.manual_activity_data.status != null) {
					this.manual_activity_data_errors.status = false;

					if (this.manual_activity_data.status == 3) {
						if ( this.manual_activity_data.actual_date != '' && this.manual_activity_data.actual_date != null) {
							this.manual_activity_data_errors.actual_date = false;
						} else {
							this.manual_activity_data_errors.actual_date = true;
						}
					} else {
						this.manual_activity_data_errors.actual_date = false;
					}

				} else {
					this.manual_activity_data_errors.status = true;
				}

				// if (this.manual_activity_data.afa_id != "" && this.manual_activity_data.afa_id != null) {
				// 	this.manual_activity_data_errors.afa_id = false;
				// } else {
				// 	this.manual_activity_data_errors.afa_id = true;
				// }

				// if (this.manual_activity_data.afa_comments != "" && this.manual_activity_data.afa_comments != null) {
				// 	this.manual_activity_data_errors.afa_comments = false;
				// } else {
				// 	this.manual_activity_data_errors.afa_comments = true;
				// }

				if (
					this.manual_activity_data_errors.name == false &&
					this.manual_activity_data_errors.scheduled_date == false &&
					this.manual_activity_data_errors.actual_date == false &&
					this.manual_activity_data_errors.communication_type == false &&
					this.manual_activity_data_errors.status == false
					// this.manual_activity_data_errors.afa_id == false &&
					// this.manual_activity_data_errors.afa_comments == false &&
				) {
					return true;
				} else {
					return false;
				}
			}

			saveManualActivityData() {
				let route: any = "";
				if (this.user_role == "Advisor Manager") {
					route = 'advisormanageractivity/';
				} else if (this.user_role == "Advisor") {
					route = '';
				} else if (this.user_role == "AFA") {
					route = '';
				} else if (this.user_role == "Assistant") {
					route = '';
				}
				let payload: any = {
					name: this.manual_activity_data.name,
					description: this.manual_activity_data.description,
					scheduled_date: moment(this.manual_activity_data.scheduled_date).format(),
					actual_date: this.manual_activity_data.actual_date != '' ? moment(this.manual_activity_data.actual_date).format() : null,
					communication_type: this.manual_activity_data.communication_type,
					status: this.manual_activity_data.status,
					afa_id: this.manual_activity_data.afa_id,
					afa_comments: this.manual_activity_data.afa_comments,
					// activity_type: 2,
					// activity_type: this.selected_activity_type,
					advisor: this.user_details.id,
					// client: this.selected_user_data.id,
					client: this.activities[this.show_inner_view].client,
				};

				if (this.user_role == "Advisor Manager") {
					payload.activity_type = this.selected_activity_type;
				} else {
					if ((this.selected_activity_type == 1 || this.selected_activity_type == 2)) {
						payload.activity_type = 2;
					} else if ((this.selected_activity_type == 3 || this.selected_activity_type == 5)) {
						payload.activity_type = 3;
					}
				}

				this.commonService.postData('route', payload).subscribe(
					(res: any) => {
						this.getClientProducts(this.selected_user_data);
						this.resetInnerViewData();
						this.resetDepositInnerViewData();
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			}

			addManualTask() {

				if (this.validateActivityData()) {
					if (this.show_capture_response == true) {
						if (this.validateCaptureResponse()) {
							this.saveActivityData();
						} else {
							this.saveActivityData();
						}
					} else {
						this.saveActivityData();
					}
				}
				// if (this.validateActivityData()) {
				// 	if (this.show_capture_response == true) {
				// 		if (this.validateCaptureResponse()) {
				// 			if (this.show_follow_up_task == true) {
				// 				if (this.validateManualActivityData()) {
				// 					if (this.show_close_deal == true) {
				// 						if (this.validateConversionStatus(this.activity_data)) {
				// 							this.saveActivityData();
				// 							// this.saveResponse();
				// 							this.saveConversionStatusData();
				// 							if (this.conversion_status_data.conversion_status == 1) {
				// 								this.saveProductInformation();
				// 							}
				// 							this.saveManualActivityData();
				// 							this.resetInnerViewData();
				// 						}
				// 					} else {
				// 						this.saveActivityData();
				// 						// this.saveResponse();
				// 						this.saveManualActivityData();
				// 						this.resetInnerViewData();
				// 					}
				// 				}
				// 			} else {
				// 				if (this.show_close_deal == true) {
				// 					if (this.validateConversionStatus(this.activity_data)) {
				// 						this.saveActivityData();
				// 						// this.saveResponse();
				// 						this.saveConversionStatusData();
				// 						if (this.conversion_status_data.conversion_status == 1) {
				// 							this.saveProductInformation();
				// 						}
				// 						this.resetInnerViewData();
				// 					}
				// 				} else {
				// 					this.saveActivityData();
				// 					// this.saveResponse();
				// 					this.resetInnerViewData();
				// 				}
				// 			}
				// 		}
				// 	} else {
				// 		this.saveActivityData();
				// 		this.resetInnerViewData();
				// 	}
				// }
			}

			addProduct() {
				// if (this.validateConversionStatus()) {
				// 	if (this.conversion_status_data.conversion_status == 1) {
				// 		if (this.user_details.role.business_area[0] == '5') {
				// 			if (this.validateProductInformation()) {
				// 				this.saveConversionStatusData(this.activities[this.show_inner_view]);
				// 			    this.saveProductInformation();
				// 			}
				// 		}
				// 		if (this.user_details.role.business_area[0] == '6') {
				// 			if (this.validateDepositProductInformation()) {
				// 				this.saveConversionStatusData(this.activities[this.show_inner_view]);
				// 				this.saveProductInformation();
				// 			}
				// 		}
				// 	}
				// 	 else {
				// 		this.saveConversionStatusData(this.activities[this.show_inner_view]);
				// 	}
				// }

				if (this.user_details.role.business_area[0] == '5') {
					if (this.validateProductInformation()) {
						this.saveProductInformation();
					}
				}
				if (this.user_details.role.business_area[0] == '6') {
					if (this.validateDepositProductInformation()) {
						this.saveProductInformation();
					}
				}

        if (this.user_details.role.business_area[0] == '7') {
					if (this.validateLendingProductInformation()) {
						this.saveProductInformation();
					}
				}

        if (this.user_details.role.business_area[0] == '8') {
					if (this.validateInsuranceProductInformation()) {
						this.saveProductInformation();
					}
				}

			}

			inner_product_tab: any = "Add Product";

			products_list: any = [];
			products_list_loader: boolean = false;
			getClientProducts(client) {
				this.show_inner_view = null;
				this.show_more_options = null;
				this.products_list_loader = true;
				let route: any = "";
				if ('is_client' in this.selected_user_data) {
					route = "/prospectinvestedproducts?prospect=" + client.id + "&no_page=true";
				} else {
					route = "/clientinvestedproducts?client=" + client.id + "&no_page=true";
				}
				this.commonService.getData(route).subscribe(
					(res: any) => {
						this.products_list = res["data"];
						this.products_list_loader = false;
					},
					(err) => {
						this.commonService.showToast('error', err.error);
						this.products_list = [];
						this.products_list_loader = false;
					},
				);
			}

			productOpeartion(data, type, index, businesss_area) {
				if (businesss_area == "Wealth Growth") {
					this.product_data = JSON.parse(JSON.stringify(data));
					this.product_operation_type = type;

					if (
						this.product_data.start_date != null &&
						this.product_data.start_date != ''
					) {
						this.product_data.start_date = new Date(this.product_data.start_date);
					} else {
						this.product_data.start_date = new Date();
					}

					if (
						this.product_data.close_date != null &&
						this.product_data.close_date != ''
					) {
						this.product_data.close_date = new Date(this.product_data.close_date);
					} else {
						this.product_data.close_date = new Date();
					}
				} else if (businesss_area == "Deposit Growth") {
					this.depositProduct_data = JSON.parse(JSON.stringify(data));
					this.product_operation_type = type;

					if (
						this.depositProduct_data.start_date != null &&
						this.depositProduct_data.start_date != ''
					) {
						this.depositProduct_data.start_date = new Date(this.depositProduct_data.start_date);
					} else {
						this.depositProduct_data.start_date = new Date();
					}

					if (
						this.depositProduct_data.close_date != null &&
						this.depositProduct_data.close_date != ''
					) {
						this.depositProduct_data.close_date = new Date(this.depositProduct_data.close_date);
					} else {
						this.depositProduct_data.close_date = new Date();
					}
				}

				this.show_inner_view = index;
				this.show_more_options = null;
			}

			updateProduct() {
				if (this.validateProductInformation() || this.validateDepositProductInformation() || this.validateLendingProductInformation() || this.validateInsuranceProductInformation()) {
					this.saveProductInformation();
				}

			}

			@ViewChild('productDeleteModal') productDeleteModal: TemplateRef<any>;
			private productDeleteModalRef: MatDialogRef<TemplateRef<any>>;
			selected_product_data: any;
			removeProduct(data) {
				this.selected_product_data = data;
				this.productDeleteModalRef = this.dialog.open(this.productDeleteModal, { disableClose: true });
				this.productDeleteModalRef.afterClosed().subscribe((result) => {
					this.closeDeleteProductModal();
				});
			}

			closeDeleteProductModal() {
				this.selected_product_data = {};
				this.show_inner_view = null;
				this.show_more_options = null;
				this.productDeleteModalRef.close();
			}

			deleteProduct() {
				this.commonService.delete('/clientproducts/destroy?ids=' + this.selected_product_data.id,).subscribe(
					(res: any) => {
						this.getClientProducts(this.selected_user_data);
						this.closeDeleteProductModal();
						this.commonService.showToast('success', 'Product Deleted Successfully.');
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			}

			openEmail(email) {
				const email_data = JSON.parse(JSON.stringify(email));
				const parser = new DOMParser();
				const html = parser.parseFromString(email_data.email_body, 'text/html');
				window.open('mailto:' + email.email + '?subject=' + email.subject + '&body=' + encodeURIComponent(html.body.innerText), '_blank',);
			}

			openProductsSection(activity, section, index) {
				this.activity_data = JSON.parse(JSON.stringify(activity));
				this.activity_opeartion_selected = section;
				this.show_inner_view = index;
				this.show_more_options = null;
			}

			outcome_data: any = {
				attrition_status: '',
				attrition_comments: '',
			};
			outcome_data_errors: any = {
				attrition_status: false,
				attrition_comments: false,
			};

			validateOutcomeStatus() {
				if (
					this.outcome_data.attrition_status != '' &&
					this.outcome_data.attrition_status != null
				) {
					this.outcome_data_errors.attrition_status = false;
				} else {
					this.outcome_data_errors.attrition_status = true;
				}

				if (
					this.outcome_data.attrition_comments != '' &&
					this.outcome_data.attrition_comments != null
				) {
					this.outcome_data_errors.attrition_comments = false;
				} else {
					this.outcome_data_errors.attrition_comments = true;
				}

				if (
					this.outcome_data_errors.attrition_status == false &&
					this.outcome_data_errors.attrition_comments == false
				) {
					// if (this.outcome_data.attrition_status == 'Retained, Upside') {
					// 	this.validateProductInformation();
					// 	this.validateDepositProductInformation();
					// 	return true;
					// }
					if (this.user_details.role.business_area[0] == '5') {
						if (this.validateProductInformation()) {
							this.validateDepositProductInformation();
							return true;
						}
					}
					if (this.user_details.role.business_area[0] == '6') {
						if (this.validateDepositProductInformation()) {
							this.validateDepositProductInformation();
							return true;
						}
					}
					else {
						return true;
					}
				} else {
					return false;
				}
			}

			saveOutcomeStatusData(data) {
				let payload: any = {
					attrition_status: this.outcome_data.attrition_status,
					attrition_comments: this.outcome_data.attrition_comments,
					// client_id: this.selected_user_data.id,
					client_id: this.activities[this.show_inner_view].client,
				};

				if (!data) {
					payload.id = "";
				} else {
					if (data.source == 'csa') {
						payload.csa_id = data.id;
					} else if (data.source == 'lpa') {
						payload.lpa_id = data.id;
					} else if (data.source == 'ama') {
						payload.ama_id = data.id;
					}
				}

				this.commonService.postData('/clientattritionoutcome/', payload).subscribe(
					(res: any) => {
						this.resetInnerViewData();
						this.resetDepositInnerViewData();
						this.commonService.showToast('success', 'Outcome Changed Successfully.',);

						this.clientStageChanged();
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			}


			addOutcome() {
				if (this.validateOutcomeStatus()) {
					if (this.outcome_data.attrition_status == 'Retained, Upside') {
						// if (this.validateProductInformation()) {
						// 	this.saveOutcomeStatusData(this.activities[this.show_inner_view]);
						// 	this.saveProductInformation();
						// }
						if (this.user_details.role.business_area[0] == '5') {
							if (this.validateProductInformation()) {
								this.saveOutcomeStatusData(this.activities[this.show_inner_view]);
								this.saveProductInformation();
							}
						}
						if (this.user_details.role.business_area[0] == '6') {
							if (this.validateDepositProductInformation()) {
								this.saveOutcomeStatusData(this.activities[this.show_inner_view]);
								this.saveProductInformation();
							}
						}

					} else {
						this.saveOutcomeStatusData(this.activities[this.show_inner_view]);
					}
				}
			}

			openOutcomeSection(activity, section, index) {
				this.activity_data = JSON.parse(JSON.stringify(activity));
				this.activity_opeartion_selected = section;
				this.show_inner_view = index;
				this.show_more_options = null;
			}


			openAssignActivitySection(activity, section, index) {
				this.activity_data = JSON.parse(JSON.stringify(activity));
				this.activity_data.scheduled_date = this.datePipe.transform(this.activity_data.scheduled_date, "MM/dd/yyyy")
				this.activity_opeartion_selected = section;
				this.show_inner_view = index;
				this.show_more_options = null;
			}

			assign_task_data: any = {
				afa: "",
				afa_comments: "",
				target_date: "",
			};
			assign_task_data_errors: any = {
				afa: false,
				afa_comments: false,
				target_date: false,
			};

			resetAssignTaskData() {
				this.activity_data = {
					name: "",
					description: "",
					scheduled_date: new Date(),
					actual_date: "",
					communication_type: "",
					status: "",
					afa_id: "",
					afa_comments: "",
				};
				this.activity_data_errors = {
					name: false,
					description: false,
					scheduled_date: false,
					actual_date: false,
					communication_type: false,
					status: false,
					afa_id: false,
					afa_comments: false,
				};
				this.activity_operation_type = "Add";

				this.assign_task_data = {
					afa: "",
					afa_comments: "",
					target_date: "",
				};
				this.assign_task_data_errors = {
					afa: false,
					afa_comments: false,
					target_date: false,
				};
				this.activity_opeartion_selected = "";
				this.show_inner_view = null;
				this.show_more_options = null;
			}

			validateAssignTask() {
				if (this.assign_task_data.afa != "" && this.assign_task_data.afa != null) {
					this.assign_task_data_errors.afa = false;
				} else {
					this.assign_task_data_errors.afa = true;
				}

				if (this.assign_task_data.afa_comments != "" && this.assign_task_data.afa_comments != null) {
					this.assign_task_data_errors.afa_comments = false;
				} else {
					this.assign_task_data_errors.afa_comments = true;
				}

				if (this.assign_task_data.target_date != "" && this.assign_task_data.target_date != null) {
					this.assign_task_data_errors.target_date = false;
				} else {
					this.assign_task_data_errors.target_date = true;
				}

				if (
					this.assign_task_data_errors.afa == false &&
					this.assign_task_data_errors.afa_comments == false &&
					this.assign_task_data_errors.target_date == false
				) {
					return true;
				} else {
					return false;
				}
			}

			saveAssignTask() {
				if (this.validateAssignTask()) {
					let payload: any = {
						afa_id: this.assign_task_data.afa,
						comments: this.assign_task_data.afa_comments,
						clientsalesactivities: [this.activity_data.id],
						user_type: [this.activity_data.user_type],
						scheduled_date: moment(this.assign_task_data.target_date).format(),
					};
					this.commonService.postData('/assignafafollowuptask/', payload).subscribe(
						(res: any) => {
							this.getClientProducts(this.selected_user_data);
							this.commonService.showToast('success', 'Activity Assigned Successfully.');
							this.resetAssignTaskData();
						},
						(err) => {
							this.commonService.showToast('error', err.error);
						},
					);
				}
			}

			unassignActivity(data) {
				let payload: any = {
					clientsalesactivities: [data.id],
					user_type: [data.user_type],
				};
				this.commonService.postData('/unassignafafollowuptask/', payload).subscribe(
					(res: any) => {
						this.getClientProducts(this.selected_user_data);
						this.commonService.showToast('success', 'Activity Unassigned Successfully.');
						this.resetAssignTaskData();
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			}

			openAssignCommentsSection(section, index) {
				this.activity_opeartion_selected = section;
				this.show_inner_view = index;
				this.show_more_options = null;
			}

			resetAssignCommentsData() {
				this.activity_opeartion_selected = "";
				this.show_inner_view = null;
				this.show_more_options = null;
			}

			openNotifyActivitySection(activity, section, index) {
				this.activity_data = JSON.parse(JSON.stringify(activity));
				this.activity_opeartion_selected = section;
				this.show_inner_view = index;
				this.show_more_options = null;
			}

			notify_advisor_comments: any = '';
			notify_advisor_comments_error: boolean = false;

			resetNotifyTaskData() {
				this.activity_data = {
					name: "",
					description: "",
					scheduled_date: new Date(),
					actual_date: "",
					communication_type: "",
					status: "",
					afa_id: "",
					afa_comments: "",
				};
				this.activity_data_errors = {
					name: false,
					description: false,
					scheduled_date: false,
					actual_date: false,
					communication_type: false,
					status: false,
					afa_id: false,
					afa_comments: false,
				};
				this.activity_operation_type = "Add";

				this.notify_advisor_comments = '';
				this.notify_advisor_comments_error = false;

				this.activity_opeartion_selected = "";
				this.show_inner_view = null;
				this.show_more_options = null;
			}

			validateNotifyTask() {
				if (this.notify_advisor_comments != "" && this.notify_advisor_comments != null) {
					this.notify_advisor_comments_error = false;
				} else {
					this.notify_advisor_comments_error = true;
				}

				if (
					this.notify_advisor_comments_error == false
				) {
					return true;
				} else {
					return false;
				}
			}

			saveNotifyTask() {
				if (this.validateNotifyTask()) {
					let payload: any = {
						comments: this.notify_advisor_comments,
						clientsalesactivities: [this.activity_data.id],
						user_type: [this.activity_data.user_type],
					};
					this.commonService.postData('/notifyleadadvisor/', payload).subscribe(
						(res: any) => {
							this.getClientProducts(this.selected_user_data);
							this.commonService.showToast('success', 'Notified to Advisor Successfully.');
							this.resetNotifyTaskData();
						},
						(err) => {
							this.commonService.showToast('error', err.error);
						},
					);

				}
			}

			openNotifyCommentsSection(activity, section, index) {
				this.getAFAComments(activity);
				this.activity_data = JSON.parse(JSON.stringify(activity));
				this.activity_opeartion_selected = section;
				this.show_inner_view = index;
				this.show_more_options = null;
			}

			resetNotifyCommentsData() {
				this.activity_data = {
					name: "",
					description: "",
					scheduled_date: new Date(),
					actual_date: "",
					communication_type: "",
					status: "",
					afa_id: "",
					afa_comments: "",
				};
				this.activity_data_errors = {
					name: false,
					description: false,
					scheduled_date: false,
					actual_date: false,
					communication_type: false,
					status: false,
					afa_id: false,
					afa_comments: false,
				};
				this.activity_operation_type = "Add";

				this.activity_opeartion_selected = "";
				this.show_inner_view = null;
				this.show_more_options = null;
			}

			notify_comments_data: any;
			getAFAComments(data) {
				this.commonService.getData('/afafollowuptaskcomments/' + data.id + '/' + data.user_type + '/')
				.subscribe(
					(res: any) => {
						this.notify_comments_data = res;
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			}


			clientStageChanged() {
				this.dataChanged.emit("Updated");
			}

			stages_list: any = [];
			getStages() {
				// let route: any = '/stage?no_page=true&financial_institution=' + this.user_details.financial_institution + "&business_area=" + this.user_details.role.business_area[0];
				let route: any = '/stage?no_page=true=&business_area=' + this.user_details.role.business_area[0];
				if (this.stepper_stage) {
					route = route + "&current_stage=" + this.stepper_stage.id + "&type=" + this.stepper_stage.type;
				}
				this.commonService.getData(route).subscribe(
					(res: any) => {
						this.stages_list = res;
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			}

			show_stage_move: boolean = false;

			move_stage_data: any = {
				stage: '',
				activity_status: false,
			};
			move_stage_data_errors: any = {
				stage: false,
				activity_status: false,
			};

			validateMoveStage() {
				if (
					this.move_stage_data.stage != '' &&
					this.move_stage_data.stage != null
				) {
					this.move_stage_data_errors.stage = false;
				} else {
					this.move_stage_data_errors.stage = true;
				}

				if (
					this.move_stage_data.stage != '' &&
					this.move_stage_data.stage != null
				) {
					this.move_stage_data_errors.stage = false;
				} else {
					this.move_stage_data_errors.stage = true;
				}

				if (
					this.move_stage_data_errors.stage == false
				) {
					return true;
				} else {
					return false;
				}
			}

			saveMoveStageData() {
				let payload: any = {
					current_stage: this.stepper_stage.id,
					target_stage:  this.move_stage_data.stage,
					client_list: [this.selected_user_data.id],
					not_required: this.move_stage_data.activity_status,
					type: this.stepper_stage.type
				};

				this.commonService.postData("/movestage/", payload).subscribe(
					(res: any) => {
						this.getActivities(this.selected_user_data)
						this.resetInnerViewData();
						this.resetDepositInnerViewData()
						this.commonService.showToast('success','Stage Changed Successfully.',);
						this.dataChanged.emit("Updated");
					},
					(err) => {
						this.commonService.showToast('error', err.error);
					},
				);
			}

			@ViewChild('activityEmailPreviewModal') activityEmailPreviewModal: TemplateRef<any>;
			private activityEmailPreviewModalRef: MatDialogRef<TemplateRef<any>>;
			activity_email_data: any;
			activity_email_data_loaded: boolean = false;
			openActivityEmailPreviewModal(activity) {
				if ((activity.activity_type == 1) || (activity.activity_type == 4) || (activity.activity_type == 5)) {
					this.activity_email_data_loaded = false;

					this.activityEmailPreviewModalRef = this.dialog.open(this.activityEmailPreviewModal, { disableClose: true });
					this.activityEmailPreviewModalRef.afterClosed().subscribe((result) => {
						this.closeActivityEmailPreviewModal();
					});

					this.commonService.getData("/emailTemplate/" + activity.email_template).subscribe(
						(res: any) => {
							this.activity_email_data = res;
							this.activity_email_data_loaded = true;
						},
						(err) => {
							this.commonService.showToast('error', err.error);
						},
					);
				}
			}

			closeActivityEmailPreviewModal() {
				this.activityEmailPreviewModalRef.close();
				this.activity_email_data = {};
				this.activity_email_data_loaded = false;
			}

			getHTML(html) {
				return this.domSanitizer.bypassSecurityTrustHtml(html);
			}

			download(link) {
				window.open(environment.apiEndpoint + '/' + link, '_blank');
			}

			sendNotification(activity, index) {
			}

			// show_activity_details: boolean = false;
			// show_activity_data: any;
			// showActivityDetails(data) {
			//   this.show_activity_data = JSON.parse(JSON.stringify(data));
			//   this.show_activity_details = true;
			// }

			// activityDetailsClosed(event) {
			// 	this.getActivities(this.selected_user_data);
			// 	this.show_activity_data = {};
			// 	this.show_activity_details = false;
			// }

			activityDetailsUpdated(event) {
				this.getActivities(this.selected_user_data);
			}

			min_amount_error: boolean = false;
			min_amount_error_text: any = "";
			checkAmountValidation(product, amount) {
				if (product != "" && product != null) {
					const index = this.product_list.findIndex((x) => x.id == product);

					if (index != -1) {
						const product = this.product_list[index];

						const product_min_amount = parseInt(product.min_balance_required);
						let aum: any = 0;
						if (amount != "" && amount != null) {
							aum = parseInt(amount);
						} else {
							aum = 0;
						}

						if (product_min_amount > aum) {
							this.min_amount_error = true;
							this.min_amount_error_text = "Amount Should be Greater than or Equal to " + product_min_amount;
						} else {
							this.min_amount_error = false;
							this.min_amount_error_text = "";
						}
					} else {
						this.min_amount_error = false;
						this.min_amount_error_text = "";
					}

				}
			}

			validateMaxValue(event, max_value): boolean {
				const charCode = event.which ? event.which : event.keyCode;

				// Allow only numeric input and the decimal point
				if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
					return false;
				}

				// Get the current value of the input field
				const inputElement = event.target as HTMLInputElement;
				const currentValue = inputElement.value;

				// Check if the input value, when modified, would exceed 100
				const newValue = currentValue + String.fromCharCode(charCode);

				if (newValue !== '.' && parseFloat(newValue) > max_value) {
					return false;
				}

				return true;
			}

			@ViewChild(ActivityTableComponent) activityTableComponent!: ActivityTableComponent;

			addIndividualManualTask() {
				// this.activityTableComponent.addIndividualManualTask();
				this.activityTableComponent.addNewManualTask();
			}

		}
